<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
        <el-form-item size="small">
          <el-select v-model="query.goodstype" clearable placeholder="请选择商品类型">
            <el-option label="库存" value="a0"></el-option>
            <el-option label="虚拟" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item size="small">
          <el-select v-model="query.brandid" clearable filterable placeholder="按品牌" @change="isnewselect = true">
            <el-option label="不分品牌" value="0"></el-option>
            <el-option v-for="(item, index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-cascader :options="categorylistsearch" v-model="query.catid" placeholder="请选择分类" clearable change-on-select
            @change="isnewselect = true"></el-cascader>
        </el-form-item>
        
        
        <el-form-item ref="query" :model="query">
          <el-input placeholder="编号 / 名称 / 条形码 / 拼音码" v-model="query.key" clearable @keyup.enter.native="getList"
            @change="isnewselect = true"></el-input>
        </el-form-item>
        <el-form-item label="有效期范围(天)" size="small">
          <el-input
            v-model="query.start_early_warning_day"
            placeholder="起始天数"
            style="width: 100px"
            @blur="validateEarlyWarningRange">
          </el-input>
          <span style="margin: 0 10px">至</span>
          <el-input
            v-model="query.end_early_warning_day"
            placeholder="结束天数"
            style="width: 100px"
            @blur="validateEarlyWarningRange">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="getList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="showgoodsbrand">查看品牌</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="showClassDialog">查看分类</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="exportdata">导出商品</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="showSynchro = true">同步线上商城</el-button>
        </el-form-item>
        <el-form-item>
          <template slot-scope="threescopesmall">
            <a href="javascript:;" @click="getsplitagents"
              style="float:left;margin-right:5%;width:2rem;height:2rem;background:#E6A23C;border-radius:50%;"><img
                src="../../assets/split.png" style="float:left;width:60%;margin:20% 0 0 20%" /></a>
          </template>
        </el-form-item>
        <el-form-item v-if="batchStatus">
          <el-button type="warning" :disabled="multipleSelection.length < 1" @click="showBatch = true">批量设置效期预警天数</el-button>
        </el-form-item>
      </el-form>
      <!------------------------search end---------------------->

      <!-- 同步线上商城 弹窗 -->
      <el-dialog title="同步线上商城商品" :visible.sync="showSynchro" width="30%">
        <!-- 提醒文字 -->
        <p style="color: #909399;">提醒: 此处开启同步线上商城，进销存商品任何信息更新时，会同步更新线上商城管理-在售商品里对应的商品数据。</p>

        <!-- 同步说明文字及开关 -->
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <span>进销存商品数据 同步 线上商城商品数据</span>
          <el-switch v-model="synchroStatus.is_open_goods_sync" active-text="开启" inactive-text="关闭" @change="synchro" />
        </div>
      </el-dialog>

      <!-- 批量设置效期预警天数 弹窗 -->
      <el-dialog title="批量设置效期预警天数" :visible.sync="showBatch" width="350px">
        <!-- 提醒文字 -->
        <div style="display: flex; align-items: center;margin-top: 10px;">
          <span style="width: 100px;">预警天数</span>
          <el-input v-model="setBatch.early_warning_day" clearable size="small"></el-input>
          <span style="width: 50px;margin-left: 8px;">天</span>
        </div>
        <div style="display: flex;justify-content: flex-end; align-items: center;margin-top: 30px;">
          <el-button @click="showBatch = false" size="small">取消</el-button>
          <el-button type="primary" size="small" @click="batchSave">确定</el-button>
        </div>
      </el-dialog>

      <!------------------------class list---------------------->
      <el-dialog title="分类管理" :visible.sync="classDialog">
        <el-form :inline="true" class="demo-form-inline" size="medium">
          <el-form-item v-if="actionauth.base_product_cate_add == 'true'">
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addClassDialog">新增分类</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="classlists" style="width: 100%">
          <!--------- 二级分类 ------------>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.child" style="width: 100%">
                <!---------- 三级分类 ----------->
                <el-table-column type="expand">
                  <template slot-scope="twoprops">
                    <el-table :data="twoprops.row.child" style="width: 100%">
                      <!---------- 四级分类 ---------->
                      <el-table-column type="expand">
                        <template slot-scope="threeprops">
                          <el-table :data="threeprops.row.child" style="width: 100%">
                            <!----- 五级分类 ---------->
                            <el-table-column type="expand">
                              <template slot-scope="fourprops">
                                <el-table :data="fourprops.row.child" style="width: 100%">
                                  <el-table-column prop="catname" label="小类名称"></el-table-column>
                                  <el-table-column label="操作" width="150"
                                    v-if="actionauth.base_product_cate_edit == 'true' || actionauth.base_product_cate_del == 'true'">
                                    <template slot-scope="fourcopesmall">
                                      <el-button type="text" size="small" @click="editClassDialog(fourcopesmall.row)"
                                        v-if="actionauth.base_product_cate_edit == 'true'">编辑</el-button>
                                      <el-button type="text" size="small" @click="delClass(fourcopesmall.row)"
                                        v-if="actionauth.base_product_cate_del == 'true'">删除</el-button>
                                    </template>
                                  </el-table-column>
                                </el-table>
                              </template>
                            </el-table-column>

                            <el-table-column prop="catname" label="小类名称"></el-table-column>
                            <el-table-column label="操作" width="150"
                              v-if="actionauth.base_product_cate_edit == 'true' || actionauth.base_product_cate_del == 'true'">
                              <template slot-scope="threescopesmall">
                                <el-button type="text" size="small" @click="editClassDialog(threescopesmall.row)"
                                  v-if="actionauth.base_product_cate_edit == 'true'">编辑</el-button>
                                <el-button type="text" size="small" @click="delClass(threescopesmall.row)"
                                  v-if="actionauth.base_product_cate_del == 'true'">删除</el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                        </template>
                      </el-table-column>

                      <el-table-column prop="catname" label="小类名称"></el-table-column>
                      <el-table-column label="操作" width="150"
                        v-if="actionauth.base_product_cate_edit == 'true' || actionauth.base_product_cate_del == 'true'">
                        <template slot-scope="twoscopesmall">
                          <el-button type="text" size="small" @click="editClassDialog(twoscopesmall.row)"
                            v-if="actionauth.base_product_cate_edit == 'true'">编辑</el-button>
                          <el-button type="text" size="small" @click="delClass(twoscopesmall.row)"
                            v-if="actionauth.base_product_cate_del == 'true'">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>

                <el-table-column prop="catname" label="小类名称"></el-table-column>
                <el-table-column label="操作" width="150"
                  v-if="actionauth.base_product_cate_edit == 'true' || actionauth.base_product_cate_del == 'true'">
                  <template slot-scope="scopesmall">
                    <el-button type="text" size="small" @click="editClassDialog(scopesmall.row)"
                      v-if="actionauth.base_product_cate_edit == 'true'">编辑</el-button>
                    <el-button type="text" size="small" @click="delClass(scopesmall.row)"
                      v-if="actionauth.base_product_cate_del == 'true'">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>

          <el-table-column label="分类名称" prop="catname"></el-table-column>
          <el-table-column label="操作" width="160"
            v-if="actionauth.base_product_cate_edit == 'true' || actionauth.base_product_cate_del == 'true'">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-edit" @click="editClassDialog(scope.row)"
                v-if="actionauth.base_product_cate_edit == 'true'"></el-button>
              <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delClass(scope.row)"
                v-if="actionauth.base_product_cate_del == 'true'"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!------------------------class list end---------------------->

      <!------------------------add class---------------------->
      <el-dialog title="新增分类" :visible.sync="createClassDialog" width="30%">
        <el-form ref="createclass" :model="createclass" :rules="classrules" label-width="100px" size="medium">
          <el-col :span="20">
            <el-form-item label="所属分类">
              <el-select v-model="createclass.parentid" placeholder="不选默认为一级分类">
                <el-option label="不选择分类" value="0"></el-option>
                <el-option v-for="(item, index) in categoryaddlistsearch" :label="item.catname" :value="item.id"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="22">
            <el-form-item label="分类名称" prop="catname">
              <el-input v-model="createclass.catname"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="createClassDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="createClassLoading" @click="createClassSave">保 存</el-button>
        </div>
      </el-dialog>
      <!------------------------add class end---------------------->

      <!------------------------edit class---------------------->
      <el-dialog title="编辑分类" :visible.sync="updateClassDialog" width="30%">
        <el-form ref="updateclass" :model="updateclass" :rules="classrules" label-width="100px" size="medium">
          <el-col :span="20">
            <el-form-item label="所属分类">
              <el-select v-model="updateclass.parentid" placeholder="请选择大分类">
                <el-option label="不选择分类" value="0"></el-option>
                <el-option v-for="(item, index) in categoryaddlistsearch" :label="item.catname" :value="item.id"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="22">
            <el-form-item label="分类名称" prop="catname">
              <el-input v-model="updateclass.catname"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="updateClassDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="updateClassLoading" @click="updateClassSave">保 存</el-button>
        </div>
      </el-dialog>
      <!------------------------edit class end---------------------->

      <!------------------------add---------------------->
      <el-dialog title="新增商品" :visible.sync="createDialog" top="1vh">
        <el-form ref="create" :model="create" :rules="rules" label-width="100px" size="small">
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="商品名称" prop="name">
                <el-input v-model="create.name" @blur="getCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="商品编号" prop="number">
                <el-input v-model="create.number"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="8">
              <el-form-item label="基本条码" prop="basebarcode">
                <el-input v-model="create.basebarcode" @blur="addsetBarcode(0)"
                  @keyup.enter.native="getBarcodeInfo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品规格" prop="spec"><el-input v-model="create.spec"></el-input></el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="商品拼音码" prop="pym">
                <el-input v-model="create.pym"></el-input>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="成本算法" prop="costtype">
                <el-select v-model="create.costtype" placeholder="成本算法">
                  <el-option label="移动加权平均" value="0"></el-option>
                  <el-option label="先进先出法" value="1"></el-option>
                  <el-option label="后进先出法" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="有效期" prop="validity">
                <el-col :span="25">
                  <el-input v-model="create.validity">
                    <template slot="append">
                      <el-button @click="checkaddvalidity">{{ validityunitname }}</el-button>
                    </template>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="商品分类" prop="catid">
                <el-cascader :options="categorylistsearch" v-model="create.catid"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="商品品牌" prop="brandid">
                <el-select v-model="create.brandid" filterable placeholder="请选择商品品牌">
                  <el-option label="不分品牌" value="0"></el-option>
                  <el-option v-for="(item, index) in brandlists" :label="item.name" :value="item.id"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="商品供应商" prop="supplierid">
                <el-select v-model="create.supplierid" filterable placeholder="请选择供应商">
                  <el-option label="不选择供应商" value="0"></el-option>
                  <el-option v-for="(item, index) in allapplylists" :label="item.apply_name" :value="item.id"
                    :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="商品产地" prop="origin">
                <el-input v-model="create.origin"></el-input>
              </el-form-item>
            </el-col>
          </el-col>

          <el-col :span="24">
            <el-col :span="23">
              <el-form-item label="商品备注" prop="note">
                <el-input v-model="create.note"></el-input>
              </el-form-item>
            </el-col>
          </el-col>

          <el-col :span="24">
            <el-tabs type="border-card">
              <el-tab-pane label="包装价格">
                <template>
                  <el-table :data="projectData" border style="width: 100%">
                    <el-table-column fixed prop="project" label="单位" width="100"></el-table-column>
                    <el-table-column label="单位名称" width="90" prop="unit" align="center">
                      <template slot-scope="scope"><el-input
                          v-model="create.unit[scope.row.index]"></el-input></template>
                    </el-table-column>
                    <el-table-column label="数量关系" width="140" align="center">
                      <template slot-scope="scope">
                        <el-input v-model="create.num[scope.row.index]" @blur="changeprice(scope.row.index, 'create')"
                          v-if="scope.row.index == 0" readonly><template slot="append"
                            v-if="create.unit[0] != ''">{{ create.unit[0] }}</template></el-input>
                        <el-input v-model="create.num[scope.row.index]" @blur="changeprice(scope.row.index, 'create')"
                          v-if="scope.row.index > 0"><template slot="append"
                            v-if="create.unit[0] != ''">{{ create.unit[0] }}</template></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="条形码" width="120" align="center">
                      <template slot-scope="scope">
                        <el-input v-model="create.barcode[scope.row.index]"
                          @blur="addunitcode(create.barcode[scope.row.index], scope.row.index, 0)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="进货价(元)" width="110" align="center">
                      <template slot-scope="scope">
                        <el-input v-model="create.buy[scope.row.index]"
                          @blur="changecolprice(scope.row.index, 'buy', -1, 'create')"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="批发价(元)" width="110" align="center">
                      <template slot-scope="scope">
                        <el-input v-model="create.sell[scope.row.index]"
                          @blur="changecolprice(scope.row.index, 'sell', -1, 'create')"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="零售价(元)" width="110" align="center">
                      <template slot-scope="scope">
                        <el-input v-model="create.market[scope.row.index]"
                          @blur="changecolprice(scope.row.index, 'market', -1, 'create')"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column v-for="(ip, key) in customerClass" prop="groupname" :label="ip.groupname" :key="key"
                      width="110" align="center">
                      <template slot-scope="scope">
                        <el-input v-model="create.other[scope.row.index][key]"
                          @blur="changecolprice(scope.row.index, 'other', key, 'create')"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-tab-pane>
              <el-tab-pane label="一品多码"><el-input type="textarea" :rows="5" placeholder="多个条形码请以换行分隔"
                  v-model="create.morebarcode"></el-input></el-tab-pane>
              <!--<el-tab-pane label="提成设置"></el-tab-pane>-->
            </el-tabs>
          </el-col>
        </el-form>
        <el-col :span="24">
          <div style="margin-top:20px"></div>
        </el-col>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="createDialog = false">取 消</el-button>
          <el-button size="small" type="primary" :loading="createLoading" @click="createSave">保 存</el-button>
        </div>
      </el-dialog>
      <!------------------------add end---------------------->

      <!------------------------edit class---------------------->
      <el-dialog title="有效期" :visible.sync="validityDialog" width="30%">
        <el-table :data="validityunits">
          <el-table-column prop="name" label="类型" style="width:70%" align="left"></el-table-column>
          <el-table-column label="操作" style="width:30%" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-check"
                @click="ensurevalidity(scope.row)">确定</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!------------------------edit class end---------------------->

      <!-- 页面主表格 -->
      <div class="backborder2" style="margin-top:10px">
        <el-table :data="lists" v-loading="listLoading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" fixed="left"></el-table-column>
          <el-table-column label="ID" prop="id" width="90"  fixed="left" />
          <el-table-column label="商品信息" min-width="480">
            <template slot-scope="scope">
              <div class="pd-infos-goods">
                <img :id="'imginfo' + scope.row.id"
                  :src="scope.row.thumb != '' && scope.row.thumb != null ? GLOBAL.staticUrl + scope.row.thumb : require('../../assets/img-default.png')" />
                <i class="pd-infos-no-inventorys" v-if="scope.row.goodstype == 1">虚拟商品</i>
              </div>
              <div class="pd-infos-desc">
                <div class="pd-infos-name">
                  {{ scope.row.brandname ? '【' + scope.row.brandname + '】' : '' }}
                  {{ scope.row.name }}
                  {{ scope.row.spec ? ' [' + scope.row.spec + '] ' : '' }}
                </div>
                <div class="pd-infos-spec">编号：{{ scope.row.number }}</div>
                <div class="pd-infos-spec">条形码：{{ scope.row.basebarcode }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="box_gauge" label="箱装规格" min-width="100" align="center"></el-table-column>
          <el-table-column label="进货价" min-width="100" align="center">
            <template slot-scope="scope">
              <div class="product-size-style">{{ scope.row.buy }}</div>
            </template>
          </el-table-column>
          <el-table-column label="批发价" min-width="100" align="center">
            <template slot-scope="scope">
              <div class="product-size-style">{{ scope.row.sell }}</div>
            </template>
          </el-table-column>
          <el-table-column label="零售价" min-width="100" align="center">
            <template slot-scope="scope">
              <div class="product-size-style">{{ scope.row.market }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="isdiscount" label="启用折扣" min-width="100" align="center">
            <template slot-scope="scope">
              <el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="discount[scope.$index]"
                @change="changediscount(scope.$index, scope.row)" v-if="scope.row.goodstype == 0"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="有效期" min-width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.realvalidity }}{{ validityunitTemp[scope.row.validityunit] }}
            </template>
          </el-table-column>

          <el-table-column label="操作" min-width="300" fixed="right" align="center"
            v-if="actionauth.base_product_edit == 'true' || actionauth.base_product_del == 'true'">
            <template slot-scope="scope">
              <el-button type="warning" size="mini" round @click="editthumbs(scope.row)"
                v-if="actionauth.base_product_supplierd_edit == 'true'">商品图设置</el-button>
              <el-button type="warning" size="mini" round @click="editCurrent(scope.row)"
                v-if="actionauth.base_product_edit == 'true'">编辑</el-button>
              <el-button type="" size="mini" round @click="delCurrent(scope.row)"
                v-if="actionauth.base_product_del == 'true'">删除</el-button>
              <el-tooltip class="item" effect="dark" :content="scope.row.kingdeesubmit == 1 ? '商品数据已同步至金蝶' : '将商品数据同步至金蝶'"
                placement="top" v-if="iskingdee == 1">
                <el-button :type="scope.row.kingdeesubmit == 1 ? 'warning' : ''" size="mini" round
                  @click="kingdeesellsubmit(scope.row)">{{ scope.row.kingdeesubmit == 1 ? '已同步' : '去同步' }}</el-button>
              </el-tooltip>

            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange" :current-page="query.p"
            :page-sizes="[10, 20, 50]" :page-size="query.rollpage" layout="total, sizes, prev, pager, next, jumper"
            :total="total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <!------------------------edit---------------------->
      <el-dialog title="编辑商品信息" :visible.sync="updateDialog" top="1vh" width="85%">
        <el-form ref="update" :model="update" :rules="rules" label-width="150px" size="small"
          class="cz-product-edit-infos">

          <div class="cz-base-product-title"><i></i>基础信息</div>
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="update.name" @blur="updategetCode" style="width:350px"></el-input>
          </el-form-item>
          <el-form-item label="规格" prop="spec">
            <el-input v-model="update.spec" style="width:auto"></el-input>
          </el-form-item>
          <el-form-item label="编号" prop="number">
            <el-input v-model="update.number" style="width:auto"></el-input>
          </el-form-item>
          <el-form-item label="拼音码" prop="pym">
            <el-input v-model="update.pym" style="width:auto"></el-input>
          </el-form-item>
          <el-form-item label="成本算法" prop="costtype">
            <el-select v-model="update.costtype" placeholder="成本算法" disabled style="width:auto">
              <el-option label="移动加权平均" value="0"></el-option>
              <el-option label="先进先出法" value="1"></el-option>
              <el-option label="后进先出法" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="有效期" prop="validity">
            <el-input v-model="update.validity" style="width:120px">
              <template slot="append">
                <el-button @click="checkaddvalidity">{{ validityunitname }}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="是否启用效期/批次" prop="basebarcode">
            <el-switch active-color="#67C23A" inactive-color="#cccccc" ></el-switch>
          </el-form-item> -->
          <el-form-item label="预警天数" prop="early_warning_day">
            <el-input v-model="update.early_warning_day" style="width:auto">
              <template slot="append">天</template>
            </el-input>
          </el-form-item>

          <el-form-item label="基本条码" prop="basebarcode">
            <el-input v-model="update.basebarcode" @blur="addsetBarcode(update.id)" style="width:auto"></el-input>
          </el-form-item>
          <el-form-item label="一品多码" prop="note">
            <el-input type="textarea" :rows="3" placeholder="多个条形码请以换行分隔" v-model="update.morebarcode"
              style="width:350px;"></el-input>
          </el-form-item>

          <div class="cz-base-product-title"><i></i>商品属性</div>
          <el-form-item label="商品类型">
            <el-select v-model="update.goodstype">
              <el-option label="库存商品" value="0"></el-option>
              <el-option label="虚拟商品" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品分类" prop="catid">
            <el-cascader :options="categorylistsearch" v-model="update.catid"></el-cascader>
          </el-form-item>
          <el-form-item label="所属品牌" prop="brand">
            <el-select v-model="update.agentbrandid" filterable placeholder="请选择商品品牌">
              <el-option label="不分品牌" value="0"></el-option>
              <el-option v-for="(item, index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商" prop="supplierid">
            <el-select v-model="update.supplierid" filterable placeholder="请选择供应商">
              <el-option label="不选择供应商" value="0"></el-option>
              <el-option v-for="(item, index) in allapplylists" :label="item.apply_name" :value="item.id"
                :key="index"></el-option>
            </el-select>
          </el-form-item>

          <div class="cz-base-product-title"><i></i>其它信息</div>
          <el-form-item label="预警库存" prop="note">
            <el-tooltip class="item" effect="dark" content="商品采购预警数量，当商品可用库存数量低于该数量时进行采购预警" placement="top">
              <el-input v-model="update.warnumber" style="width:100px;" />
            </el-tooltip>
          </el-form-item>
          <el-form-item label="产地" prop="origin">
            <el-input type="textarea" v-model="update.origin" :rows="3" style="width:350px;min-height:50px"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="note">
            <el-input type="textarea" v-model="update.note" :rows="3" style="width:350px;min-height:50px"></el-input>
          </el-form-item>

          <div class="cz-base-product-title"><i></i>包装价格</div>
          <div style="display:inline-block;width:calc(100% - 40px);padding:0 20px;">
            <el-table :data="projectData" border style="width:100%">
              <el-table-column fixed prop="project" label="单位" min-width="150">
                <template slot-scope="scope">
                  <span style="font-size:13px;">{{ scope.row.project }}{{ scope.$index > 0 ? '_' + scope.$index : '' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="单位名称" prop="unit" align="center" min-width="150">
                <template slot-scope="scope">
                  <el-input size="small" v-model="update.unit[scope.row.index]"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="数量关系" align="center" min-width="150">
                <template slot-scope="scope">
                  <el-input size="small" v-model="update.num[scope.row.index]"
                    @blur="changeprice(scope.row.index, 'update')" v-if="scope.row.index == 0" readonly><template
                      slot="append" v-if="update.unit[0] != ''">{{ update.unit[0] }}</template></el-input>
                  <el-input size="small" v-model="update.num[scope.row.index]"
                    @blur="changeprice(scope.row.index, 'update')" v-if="scope.row.index > 0"><template slot="append"
                      v-if="update.unit[0] != ''">{{ update.unit[0] }}</template></el-input>
                </template>
              </el-table-column>
              <el-table-column label="条形码" align="center" min-width="150">
                <template slot-scope="scope"><el-input size="small" v-model="update.barcode[scope.row.index]"
                    @blur="addunitcode(update.barcode[scope.row.index], scope.row.index, update.id)"></el-input></template>
              </el-table-column>
              <el-table-column label="进货价(元)" align="center" min-width="150">
                <template slot-scope="scope">
                  <el-input size="small" v-model="update.buy[scope.row.index]"
                    @blur="changecolprice(scope.row.index, 'buy', -1, 'update')"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="批发价(元)" align="center" min-width="150">
                <template slot-scope="scope">
                  <el-input size="small" v-model="update.sell[scope.row.index]"
                    @blur="changecolprice(scope.row.index, 'sell', -1, 'update')"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="零售价(元)" align="center" min-width="150">
                <template slot-scope="scope">
                  <el-input size="small" v-model="update.market[scope.row.index]"
                    @blur="changecolprice(scope.row.index, 'market', -1, 'update')"></el-input>
                </template>
              </el-table-column>
              <el-table-column v-for="(ip, key) in customerClass" prop="groupname" :label="ip.groupname" :key="key"
                align="center" min-width="150">
                <template slot-scope="scope">
                  <el-input size="small" v-model="update.other[scope.row.index][key]"
                    @blur="changecolprice(scope.row.index, 'other', key, 'update')"></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="cz-base-product-title"><i></i>库存信息</div>
          <div style="display:inline-block;width:calc(100% - 40px);padding:0 20px;">
            <el-table :data="update.inventory" border>
              <el-table-column prop="warehousename" label="仓库名称" align="center">
                <template slot-scope="scope">
                  <span style="font-size:13px;">{{ scope.row.warehousename }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="unit" label="库存" align="center">
                <template slot-scope="scope">
                  <span style="font-size:13px;">{{ scope.row.unit }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>


          <div class="cz-base-product-title"><i></i>进货跟踪</div>
          <div style="display:inline-block;width:calc(100% - 40px);padding:0 20px;">
            <el-table :data="update.allprice" border>
              <el-table-column prop="name" label="名称" align="center">
                <template slot-scope="scope">
                  <span style="font-size:13px;">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="price" label="价格" align="center">
                <template slot-scope="scope">
                  <span style="font-size:13px;">{{ scope.row.price }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>


          <!--
            <el-col :span="24">
              <el-col :span="16">
                <el-form-item label="商品名称" prop="name">
                  <el-input v-model="update.name" @blur="updategetCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="编号" prop="number">
                  <el-input v-model="update.number"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
            
            <el-col :span="24">
            	<el-col :span="12">
	            	<el-form-item label="商品类型">
	                  <el-select v-model="update.goodstype">
	                     <el-option label="库存商品" value="0"></el-option>
	                     <el-option label="虚拟商品" value="1"></el-option>
	                  </el-select>
	                </el-form-item>
                </el-col>
                <el-col :span="11">
	                <el-form-item label="拼音码" prop="pym">
	                  <el-input v-model="update.pym"></el-input>
	                </el-form-item>
                </el-col>
            </el-col>
            
            <el-col :span="24">
              <el-col :span="12">
                <el-form-item label="基本条码" prop="basebarcode">
                  <el-input v-model="update.basebarcode" @blur="addsetBarcode(update.id)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="规格" prop="spec"><el-input v-model="update.spec"></el-input></el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="12">
                <el-form-item label="成本算法" prop="costtype">
                  <el-select v-model="update.costtype" placeholder="成本算法" disabled >
                    <el-option label="移动加权平均" value="0"></el-option>
                    <el-option label="先进先出法" value="1"></el-option>
                    <el-option label="后进先出法" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>              
              <el-col :span="11">
                <el-form-item label="有效期" prop="validity">
                	<el-col :span="25">
	                    <el-input v-model="update.validity">
	                        <template slot="append">
	                			<el-button @click="checkaddvalidity">{{validityunitname}}</el-button>
	                        </template>
	                    </el-input>
                    </el-col>
                </el-form-item>
              </el-col> 
            </el-col>
            <el-col :span="24">
              <el-col :span="12">
                <el-form-item label="商品分类" prop="catid">
                  <el-cascader :options="categorylistsearch" v-model="update.catid"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="品牌" prop="brandid">
                  <el-select v-model="update.agentbrandid" filterable placeholder="请选择商品品牌">
                    <el-option label="不分品牌" value="0"></el-option>
                    <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                    	<span style="float: left">{{item.name}}</span>
      				    <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
                <el-col :span="12">
	                <el-form-item label="供应商" prop="supplierid">
	                    <el-select v-model="update.supplierid" filterable placeholder="请选择供应商">
	                    	<el-option label="不选择供应商" value="0"></el-option>
	                        <el-option v-for="(item,index) in allapplylists" :label="item.apply_name" :value="item.id" :key="index"></el-option>
	                    </el-select>
	                </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="产地" prop="origin">
                        <el-input v-model="update.origin"></el-input>
                    </el-form-item>
                </el-col>
            </el-col>
            
            <el-col :span="24">
                <el-col :span="12">
                    <el-form-item label="预警库存" prop="note">
                        <el-tooltip class="item" effect="dark" content="商品采购预警数量，当商品可用库存数量低于该数量时进行采购预警" placement="top">
                        <el-input v-model="update.warnumber" />
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="备注" prop="note">
                        <el-input v-model="update.note"></el-input>
                    </el-form-item>
                </el-col>
            </el-col>
            
            <el-col :span="24">
            <el-tabs type="border-card">
              <el-tab-pane label="包装价格">
                <template>
                  <el-table :data="projectData" border style="width: 100%">
                    <el-table-column fixed prop="project" label="单位" width="120"></el-table-column>
                    <el-table-column label="单位名称" width="80" prop="unit">
                      <template slot-scope="scope">
                      	<el-input v-model="update.unit[scope.row.index]"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="数量关系" width="140">
                      <template slot-scope="scope">
                      	<el-input v-model="update.num[scope.row.index]" @blur="changeprice(scope.row.index,'update')" v-if="scope.row.index==0" readonly><template slot="append" v-if="update.unit[0]!=''">{{update.unit[0]}}</template></el-input>
                        <el-input v-model="update.num[scope.row.index]" @blur="changeprice(scope.row.index,'update')" v-if="scope.row.index > 0"><template slot="append" v-if="update.unit[0]!=''">{{update.unit[0]}}</template></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="条形码" width="120">
                      <template slot-scope="scope"><el-input v-model="update.barcode[scope.row.index]"  @blur="addunitcode(update.barcode[scope.row.index],scope.row.index,update.id)"></el-input></template>
                    </el-table-column>
                    <el-table-column label="进货价(元)" width="110">
                      <template slot-scope="scope">
                        <el-input v-model="update.buy[scope.row.index]" @blur="changecolprice(scope.row.index,'buy',-1,'update')"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="批发价(元)" width="110">
                      <template slot-scope="scope">
                        <el-input v-model="update.sell[scope.row.index]" @blur="changecolprice(scope.row.index,'sell',-1,'update')"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="零售价(元)" width="110">
                      <template slot-scope="scope">
                        <el-input v-model="update.market[scope.row.index]" @blur="changecolprice(scope.row.index,'market',-1,'update')"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column v-for="(ip,key) in customerClass" prop="groupname" :label="ip.groupname" :key="key" width="110">
                      <template slot-scope="scope">
                        <el-input v-model="update.other[scope.row.index][key]" @blur="changecolprice(scope.row.index,'other',key,'update')"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-tab-pane>
              <el-tab-pane label="一品多码">
              	  <el-input type="textarea" :rows="5" placeholder="多个条形码请以换行分隔" v-model="update.morebarcode"></el-input>
              </el-tab-pane>
              <el-tab-pane label="库存信息">
                  <el-table :data="update.inventory" border>
            		  <el-table-column prop="warehousename" label="仓库名称" width="150"></el-table-column>
            		  <el-table-column prop="unit" label="库存"></el-table-column>
            	  </el-table>
              </el-tab-pane>
              <el-tab-pane label="进货跟踪">
              	  <el-table :data="update.allprice" border>
            		  <el-table-column prop="name" label="名称" width="150"></el-table-column>
            		  <el-table-column prop="price" label="价格"></el-table-column>
            	  </el-table>
              </el-tab-pane>
            </el-tabs>
            </el-col>
            -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="updateDialog = false">取 消</el-button>
          <el-button size="small" type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
        </div>
      </el-dialog>
      <!------------------------edit end---------------------->

      <!------------------------apply lists start---------------------->
      <el-dialog title="供应商列表" :visible.sync="showSupplierDialog" top="5vh" width="90%">
        <el-form :inline="true" class="demo-form-inline" size="medium">
          <el-form-item>
            <el-input placeholder="供应商名称 / 公司名称  /  联系人姓名  /  联系电话  /  开户银行 / 税率" v-model="applyquery.key"
              @change="applychange = true" @keyup.enter.native="getApplylists" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getApplylists">查询</el-button>
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="showaddSupplierDialog = true"
              v-if="actionauth.base_product_supplierd_add == 'true'">新增供应商</el-button>
          </el-form-item>
        </el-form>

        <el-table :data="applylists" v-loading="ApplyLoading">
          <el-table-column prop="id" label="编号" width="65"></el-table-column>
          <el-table-column prop="apply_name" label="供应商名称"></el-table-column>
          <el-table-column prop="company" label="公司名称"></el-table-column>
          <el-table-column prop="truename" label="联系姓名" width="90" align="center"></el-table-column>
          <el-table-column prop="phone" label="联系电话" width="115" align="center"></el-table-column>
          <el-table-column prop="bank" label="开户银行" width="110"></el-table-column>
          <el-table-column prop="rate" label="税率（%）" width="100" align="center"></el-table-column>
          <el-table-column prop="snumbers" label="关联商品数量" width="105" align="center"></el-table-column>
          <el-table-column label="操作" width="150"
            v-if="actionauth.base_product_supplierd_edit == 'true' || actionauth.base_product_supplierd_del == 'true'"
            align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-edit" @click="editApplyCurrent(scope.row)"
                v-if="actionauth.base_product_supplierd_edit == 'true'"></el-button>
              <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delApplyCurrent(scope.row)"
                v-if="actionauth.base_product_supplierd_del == 'true'"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="pageSizeapplyChange" @current-change="pageapplyCurrentChange"
            :current-page="applyquery.p" :page-sizes="[10, 20, 50]" :page-size="applyquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="apply_total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </el-dialog>
      <!------------------------apply lists end---------------------->

      <!------------------------add apply start---------------------->
      <el-dialog title="新增供应商" :visible.sync="showaddSupplierDialog" top="10vh">
        <el-form ref="addsupplyclass" :model="localapply" :rules="classrules" width="60%" size="medium">
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="商家名称" prop="name">
                <el-col :span="16"><el-input v-model="createapply.apply_name"></el-input></el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司名称" prop="company">
                <el-col :span="18"><el-input v-model="createapply.company"></el-input></el-col>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="公司税率" prop="rate">
                <el-col :span="16">
                  <el-input v-model="createapply.rate">
                    <template slot="append">%</template>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司税号" prop="rateid">
                <el-col :span="18"><el-input v-model="createapply.rateid"></el-input></el-col>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="开户银行" prop="bank">
                <el-col :span="16"><el-input v-model="createapply.bank"></el-input></el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行账号" prop="banknumber">
                <el-col :span="18"><el-input v-model="createapply.banknumber"></el-input></el-col>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="联系姓名" prop="truename">
                <el-col :span="16"><el-input v-model="createapply.truename"></el-input></el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="phone">
                <el-col :span="18"><el-input v-model="createapply.phone"></el-input></el-col>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系地址" prop="address">
              <el-col :span="21"><el-input v-model="createapply.address"></el-input></el-col>
            </el-form-item>
          </el-col>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="showaddSupplierDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="updatesuppleraddLoading" @click="addsupplySave">保
            存</el-button>
        </div>
      </el-dialog>
      <!------------------------add apply end------------------------>

      <!------------------------edit apply start---------------------->
      <el-dialog title="编辑供应商" :visible.sync="showeditSupplierDialog" top="10vh" width="60%"
        v-loading="editapplyLoading">
        <el-form size="medium">
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="商家名称">
                <el-col :span="16"><el-input v-model="editapply.apply_name"></el-input></el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司名称">
                <el-col :span="18"><el-input v-model="editapply.company"></el-input></el-col>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="公司税率">
                <el-col :span="16">
                  <el-input v-model="editapply.rate">
                    <template slot="append">%</template>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公司税号">
                <el-col :span="18"><el-input v-model="editapply.rateid"></el-input></el-col>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="开户银行">
                <el-col :span="16"><el-input v-model="editapply.bank"></el-input></el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行账号">
                <el-col :span="18"><el-input v-model="editapply.banknumber"></el-input></el-col>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item label="联系姓名">
                <el-col :span="16"><el-input v-model="editapply.truename"></el-input></el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话">
                <el-col :span="18"><el-input v-model="editapply.phone"></el-input></el-col>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系地址">
              <el-col :span="21"><el-input v-model="editapply.address"></el-input></el-col>
            </el-form-item>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="showeditSupplierDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="updatesupplereditLoading" @click="editsupplySave">保
            存</el-button>
        </div>
      </el-dialog>
      <!------------------------edit apply end------------------------>

      <!------------------------批量新增商品 start---------------------->
      <el-dialog title="批量导入新增商品" :visible.sync="showSlmoreDialog" top="10vh" width="88%">
        <el-tag type="danger">温馨提示：该功能需要您点击下载宠老板代理端商品信息上传模板并认真填写商品信息，谢绝自定义模板</el-tag>
        <div style="width:100%;margin-top:20px">
          <input id="fileupload" type="file" @change="importfile(this)"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            style="display:none" title="1" />
          <el-button type="success" size="small" icon="el-icon-upload2" @click="uploadinfos">上传文件</el-button>
          <el-button type="primary" size="small" icon="el-icon-download" @click="downmodel">下载模板</el-button>
          <el-button type="primary" size="small" icon="el-icon-tickets" @click="mygoodssupply"
            style="float:right">查看我的供应商</el-button>
          <el-button type="primary" size="small" icon="el-icon-goods" @click="mygoodsbrand"
            style="float:right">查看我的品牌</el-button>
          <el-button type="primary" size="small" icon="el-icon-menu" @click="mygoodscate"
            style="float:right">查看我的分类</el-button>
        </div>
        <el-table :data="productsmore" v-loading="uploadgoodsLoading" style="width:100%;margin-top:20px">
          <el-table-column prop="number" label="编号" align="left"></el-table-column>
          <el-table-column prop="name" label="名称" align="left"></el-table-column>
          <el-table-column prop="basecode" label="基本条码" align="left"></el-table-column>
          <el-table-column prop="costtype" label="成本算法" align="left"></el-table-column>
          <el-table-column prop="validity" label="有效期（天）" align="center"></el-table-column>
          <el-table-column prop="spec" label="规格" align="center"></el-table-column>
          <el-table-column prop="catid" label="商品分类" align="left"></el-table-column>
          <el-table-column prop="brandid" label="品牌" align="left"></el-table-column>
          <el-table-column prop="supplierid" label="供应商" align="left"></el-table-column>
          <el-table-column prop="unit" label="单位名称" align="center"></el-table-column>
          <el-table-column prop="buy" label="进货价" align="center"></el-table-column>
          <el-table-column prop="sell" label="批发价" align="center"></el-table-column>
          <el-table-column prop="market" label="零售价" align="center"></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" circle icon="el-icon-delete"
                @click="delinfos(scope.$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="showSlmoreDialog = false">取 消</el-button>
          <el-button size="small" type="primary" :loading="saveexcelLoading" @click="inputinfosSave">保 存</el-button>
        </div>
      </el-dialog>
      <!------------------------批量新增商品 end------------------------>

      <!------------------------ 我的分类管理 ---------------------->
      <el-dialog title="我的商品分类" :visible.sync="myclassDialog" top="5vh" width="50%">
        <el-table :data="mycate" v-loading="myclassLoading" style="width:100%">
          <el-table-column label="名称" prop="catname"></el-table-column>
        </el-table>
        <!--分页begin-->
        <div class="block">
          <el-pagination @size-change="mypageSizeChange" @current-change="mypageCurrentChange"
            :current-page="mycatequery.p" :page-sizes="[10, 20, 50]" :page-size="mycatequery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="my_cate_total_rows">
          </el-pagination>
        </div>
        <!--分页end-->
      </el-dialog>
      <!------------------------class list end---------------------->

      <!------------------------ 我的品牌 ---------------------->
      <el-dialog title="我的品牌" :visible.sync="mybrandDialog" top="5vh" width="50%">
        <el-table :data="mybrand" v-loading="mybrandLoading" style="width:100%">
          <el-table-column label="名称" prop="name"></el-table-column>
        </el-table>
        <!--分页begin-->
        <div class="block">
          <el-pagination @size-change="mybrandpageSizeChange" @current-change="mybrandpageCurrentChange"
            :current-page="mybrandquery.p" :page-sizes="[10, 20, 50]" :page-size="mybrandquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="my_brand_total_rows">
          </el-pagination>
        </div>
        <!--分页end-->
      </el-dialog>
      <!------------------------class list end---------------------->

      <!------------------------ 我的供应商 ---------------------->
      <el-dialog title="我的供应商" :visible.sync="mysupplyDialog" top="5vh" width="50%">
        <el-table :data="mysupply" v-loading="mysupplyLoading" style="width:100%">
          <el-table-column label="名称" prop="apply_name"></el-table-column>
        </el-table>
        <!--分页begin-->
        <div class="block">
          <el-pagination @size-change="mysupplypageSizeChange" @current-change="mysupplypageCurrentChange"
            :current-page="mysupplyquery.p" :page-sizes="[10, 20, 50]" :page-size="mysupplyquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="my_supply_total_rows">
          </el-pagination>
        </div>
        <!--分页end-->
      </el-dialog>
      <!------------------------class list end---------------------->

      <!-----------------------  品牌管理  --------------------------->
      <el-dialog title="品牌管理" :visible.sync="brandDialog" top="5vh" width="55%">
        <el-form :inline="true" class="demo-form-inline" size="medium">
          <el-form-item ref="query" :model="query">
            <el-input placeholder="请输入关键字" v-model="brandquery.key" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getbrandlists">查询</el-button>
          </el-form-item>
          <el-form-item v-if="actionauth.base_brand_add == 'true'">
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addcreatebrandinfo">新增品牌</el-button>
          </el-form-item>
        </el-form>

        <el-table :data="brandquerylists" v-loading="brandlistLoading">
          <el-table-column label="图片" width="120">
            <template slot-scope="scope">
              <img :src="scope.row.thumb" v-if="scope.row.thumb != '' && scope.row.thumb != null"
                style="width:80%;border-radius:6px;">
              <img src="../../assets/default_img_mini.png" v-if="scope.row.thumb == '' || scope.row.thumb == null"
                style="width:80%;border-radius:6px;">
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="primary" size="small" circle icon="el-icon-edit" @click="editbrandCurrent(scope.row)"
                v-if="actionauth.base_brand_update == 'true'"></el-button>
              <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delbrandCurrent(scope.row)"
                v-if="actionauth.base_brand_del == 'true'"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="brandpageSizeChange" @current-change="brandpageCurrentChange"
            :current-page="query.p" :page-sizes="[10, 20, 50]" :page-size="query.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="brand_total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </el-dialog>

      <el-dialog title="新增品牌" :visible.sync="createbrandDialog">
        <el-form ref="create" :model="create" label-width="100px" size="medium">
          <el-col :span="23">
            <el-form-item label="品牌名称">
              <el-input v-model="createbrand.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="23">&nbsp;</el-col>

          <el-col :span="23">
            <el-form-item label="品牌缩略图">
              <el-tag type="danger">温馨提示：建议上传115px * 56px的图片，图片的大小不超过50k</el-tag>
              <input @change="filecreateminiChange($event, 'create')" type="file" id="upload_file">
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item>
              <img :src="createbrand.showthumb" style="width:30%;"
                v-if="createbrand.thumb != '' && createbrand.thumb != null">
              <img src="../../assets/default_img_mini.png" style="width:30%;"
                v-if="createbrand.thumb == '' || createbrand.thumb == null">
            </el-form-item>
          </el-col>

          <el-col :span="23">
            <el-form-item label="展示宣传图">
              <el-tag type="danger">温馨提示：建议上传345px * 168px的图片，图片的大小不超过300k</el-tag>
              <input @change="filecreateChange($event, 'create')" type="file" id="upload_file">
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item>
              <img :src="createbrand.showthumbbanner" style="width:70%;"
                v-if="createbrand.bannerthumb != '' && createbrand.bannerthumb != null">
              <img src="../../assets/default_img.png" style="width:70%;"
                v-if="createbrand.bannerthumb == '' || createbrand.bannerthumb == null">
            </el-form-item>
          </el-col>

          <el-col :span="23">&nbsp;</el-col>
          <el-col :span="23">
            <el-form-item label="线上商城展示">
              <template slot-scope="scope">
                <el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="createbrand.showmallstatus"
                  @change="changeshowmall('create')"></el-switch>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item label="绑定品类">
              <el-checkbox v-for="(item, index) in createbrand.cate" v-model="item.status"
                :key="index">{{ item.name }}</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item label="绑定分类">
              <el-button type="primary" size="small" icon="el-icon-circle-plus-outline"
                @click="addbrandCurrent()">新增绑定分类</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
              <el-tag type="danger">温馨提示：用于宠老板进货商城分类搜索品牌信息</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item>
              <el-table :data="createbrand.category" border>
                <el-table-column prop="catname" label="分类名称">
                  <template slot-scope="scope">
                    <el-input v-model="createbrand.category[scope.$index].catname"
                      @focus="addbrandcate(scope.row, scope.$index, 'create')" style="width:70%" readonly></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="90">
                  <template slot-scope="scope">
                    <el-button type="danger" size="small" icon="el-icon-circle-close-outline" circle
                      @click="delbrandcate(scope.$index)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="createbrandDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="createbrandLoading" @click="createbrandSave">保 存</el-button>
        </div>
      </el-dialog>

      <el-dialog title="编辑品牌" :visible.sync="updatebrandDialog">
        <el-form ref="update" :model="update" label-width="100px" size="medium">
          <el-col :span="23">
            <el-form-item label="品牌名称" prop="name">
              <el-input v-model="updatebrand.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item>
              <el-tag type="danger">温馨提示：建议上传100px * 50px的图片，图片的大小不超过300k</el-tag>
              <input @change="filecreateminiChange($event, 'update')" type="file" id="upload_file">
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item>
              <img :src="updatebrand.showthumb" style="width:40%;border:1px solid #cccccc"
                v-if="updatebrand.thumb != '' && updatebrand.thumb != null">
              <img src="../../assets/default_img.png" style="width:40%;border:1px solid #cccccc"
                v-if="updatebrand.thumb == '' || updatebrand.thumb == null">
            </el-form-item>
          </el-col>

          <el-col :span="23">
            <el-form-item label="展示宣传图">
              <el-tag type="danger">温馨提示：建议上传345px * 168px的图片，图片的大小不超过300k</el-tag>
              <input @change="filecreateChange($event, 'update')" type="file" id="upload_file">
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item>
              <img :src="updatebrand.showthumbbanner" style="width:70%;"
                v-if="updatebrand.bannerthumb != '' && updatebrand.bannerthumb != null">
              <img src="../../assets/default_img.png" style="width:70%;"
                v-if="updatebrand.bannerthumb == '' || updatebrand.bannerthumb == null">
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item label="绑定品类">
              <el-checkbox v-for="(item, index) in updatebrand.cate" v-model="item.status"
                :key="index">{{ item.name }}</el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="23">&nbsp;</el-col>
          <el-col :span="23">
            <el-form-item label="线上商城展示">
              <template slot-scope="scope">
                <el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="updatebrand.showmallstatus"
                  @change="changeshowmall('update')"></el-switch>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item label="绑定分类">
              <el-button type="primary" size="small" icon="el-icon-circle-plus-outline"
                @click="updatebrandCurrent()">新增绑定分类</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
              <el-tag type="danger">温馨提示：用于宠老板进货商城分类搜索品牌信息</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item>
              <el-table :data="updatebrand.category" border>
                <el-table-column prop="catname" label="分类名称">
                  <template slot-scope="scope">
                    <el-input v-model="updatebrand.category[scope.$index].catname"
                      @focus="addbrandcate(scope.row, scope.$index, 'update')" style="width:70%" readonly></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="90">
                  <template slot-scope="scope">
                    <el-button type="danger" size="small" icon="el-icon-circle-close-outline" circle
                      @click="delupdatebrandcate(scope.$index)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="updatebrandDialog = false">取 消</el-button>
          <el-button size="medium" type="primary" :loading="updatebrandLoading" @click="updatebrandSave">保 存</el-button>
        </div>
      </el-dialog>

      <el-dialog title="选择绑定品牌分类" :visible.sync="brandcategoryDialog" width="30%">
        <el-form>
          <el-col :span="23">
            <el-form-item>
              <el-cascader :options="brandcategorylists" v-model="selectcategory.brandcategoryid"></el-cascader>
            </el-form-item>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="brandcategoryDialog = false">取 消</el-button>
          <el-button type="primary" :loading="brandcategoryLoading" @click="brandcategorysave">保 存</el-button>
        </div>
      </el-dialog>

      <!---------------------------- 导出信息确认 ---------------------------->
      <el-dialog title="导出信息确认" :visible.sync="exportDialog" width="98%" top="5vh">
        <el-button type="danger" @click="sureoutput"
          style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
        <div id="outputorder">
          <el-table :data="exportlists" border v-loading="exportLoading">
            <el-table-column prop="name" label="商品名称" width="90"></el-table-column>
            <el-table-column prop="number" label="编号" width="90"></el-table-column>
            <el-table-column prop="basebarcode" label="基本条码"></el-table-column>
            <el-table-column prop="spec" label="规格"></el-table-column>
            <el-table-column prop="box_gauge" label="箱装规格"></el-table-column>
            <el-table-column prop="costtype" label="成本算法" align="center"></el-table-column>
            <el-table-column prop="realvalidity" label="有效期（天）" align="center"></el-table-column>
            <el-table-column prop="catname" label="商品分类" width="100" align="center"></el-table-column>
            <el-table-column prop="brandname" label="品牌" width="100" align="center"></el-table-column>
            <el-table-column prop="applyname" label="供应商" width="100" align="center"></el-table-column>
            <el-table-column prop="unit" label="单位名称" width="100" align="center"></el-table-column>
            <el-table-column prop="buy" label="进货价" align="center"></el-table-column>
            <el-table-column prop="sell" label="批发价" align="center"></el-table-column>
            <el-table-column prop="market" label="零售价" align="center"></el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="exportDialog = false">取 消</el-button>
          <el-button type="danger" @click="sureoutput">确认导出</el-button>
        </div>
      </el-dialog>

      <!------- 商品图片信息集合 ------------>
      <el-dialog title="商品图片信息" :visible.sync="thumbDialog" width="50%" top="5vh">
        <div v-loading="thumbloading" style="overflow:hidden;position:relative">
          <ul class="imglists">
            <li style="background:none;border:1px dashed #cccccc">
              <input type="file" id="adimg" style="display:none" @change="getadimgb($event)" />
              <a @click="getadimga()"><img src="../../assets/add-default.png"
                  style="max-width:55%;max-height:55%" /></a>
            </li>
            <li v-for="(item, index) in thumbs" :key="index">
              <img :src="GLOBAL.staticUrl + item.url" />
              <a @click="closethumb(index)" class="thumbclose"><img src="@/assets/error-full.png" /></a>
              <a @click="selectdefaultthumb(index)" class="thumbdefault">
                <img
                  :src="item.isdefault == 0 ? require('@/assets/right_default_full.png') : require('@/assets/right_select_full.png')" />
              </a>
            </li>
          </ul>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="thumbDialog = false">取 消</el-button>
          <el-button size="small" type="danger" @click="savethumbs">保存</el-button>
        </div>
      </el-dialog>

      <!-- 设置商品对应金蝶物料id -->
      <el-dialog title="商品图片信息" :visible.sync="kingdeeDialog" width="50%" top="5vh">
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item label-width="120" label="绑定金蝶物料信息">
            <el-select v-model="setkingdeequery.kingdeename" clearable filterable remote reserve-keyword
              :remote-method="getkingdeegoodslists" :loading="customergetLoading" placeholder="客户名称 / 编码 / 组织号"
              @change="changekingdeesetting">
              <el-option v-for="(item, index) in kingdeelists" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="kingdeeDialog = false">取 消</el-button>
          <el-button size="small" type="danger" @click="savematchkingdee">保存</el-button>
        </div>
      </el-dialog>

    </div>
  </transition>
</template>

<script>
import { set } from 'nprogress';


export default {
  data() {
    return {
      actionauth: '', //操作功能权限
      url: this.GLOBAL.domain + "Product/index",
      datacenter: this.$cookies.get('datacenter'),
      transitionshow: true,
      lists: [],
      brandlists: [],
      categorylist: [],
      categorylistsearch: [],
      applylists: [],
      allapplylists: [],
      createapply: {
        act: 'addapply',
        token: this.$cookies.get('token'),
        apply_name: '',
        company: '',
        rate: '',
        rateid: '',
        bank: '',
        banknumber: '',
        truename: '',
        phone: '',
        address: '',
      },
      editapply: {
        act: 'editapply',
        token: this.$cookies.get('token'),
        id: '',
        apply_name: '',
        company: '',
        rate: '',
        rateid: '',
        bank: '',
        banknumber: '',
        truename: '',
        phone: '',
        address: '',
      },
      localapply: [],
      productsmore: [],
      infos: [],
      validityunitname: '日',
      validityunits: [ //有效期时间类型
        { id: 1, name: '日' },
        { id: 2, name: '月' },
        { id: 3, name: '年' },
      ],

      listLoading: false,
      ApplyLoading: false,
      uploadgoodsLoading: false,
      updatesuppleraddLoading: false,
      updatesupplereditLoading: false,
      myclassLoading: false,
      mybrandLoading: false,
      mysupplyLoading: false,
      saveexcelLoading: false,
      query: {
        act: 'lists',
        token: this.$cookies.get('token'),
        goodstype: '',
        brandid: '',
        catid: '',
        key: '',
        start_early_warning_day: null,
        end_early_warning_day: null,
        rollpage: 10, // 页大小
        p: 1
      },
      applyquery: {
        url: this.GLOBAL.domain + "Product/index",
        act: 'getapplylists',
        token: this.$cookies.get('token'),
        key: '',
        rollpage: 10, // 页大小
        p: 1
      },
      allapplyquery: {
        url: this.GLOBAL.domain + "Product/index",
        act: 'getapplyAll',
        token: this.$cookies.get('token'),
      },
      mycatequery: {
        url: this.GLOBAL.domain + "Product/index",
        act: 'getmycate',
        token: this.$cookies.get('token'),
        rollpage: 10, // 页大小
        p: 1
      },
      mybrandquery: {
        url: this.GLOBAL.domain + "Brand/index",
        act: 'lists',
        token: this.$cookies.get('token'),
        rollpage: 10, // 页大小
        p: 1
      },
      mysupplyquery: {
        url: this.GLOBAL.domain + "Product/index",
        act: 'getapplylists',
        token: this.$cookies.get('token'),
        rollpage: 10, // 页大小
        p: 1
      },

      total_rows: 0,
      apply_total_rows: 0,
      my_cate_total_rows: 0,
      my_brand_total_rows: 0,
      my_supply_total_rows: 0,
      createDialog: false,
      showSupplierDialog: false,
      showaddSupplierDialog: false,
      showeditSupplierDialog: false,
      showSlmoreDialog: false,
      validityDialog: false,
      createLoading: false,
      myclassDialog: false,
      mybrandDialog: false,
      mysupplyDialog: false,
      create: {
        act: 'add',
        token: this.$cookies.get('token'),
        name: '',
        number: '',
        basebarcode: '',
        spec: '',
        pym: '',
        costtype: '0',
        validity: '',
        validityunit: 1,
        catid: [],
        brandid: '',
        origin: '',
        note: '',
        morebarcode: '',
        unit: [],
        num: [],
        barcode: [],
        buy: [],
        sell: [],
        market: [],
        other: {
          0: [],
          1: [],
          2: []
        },
        iskingdee: 0,
      },
      updateDialog: false,
      updateLoading: false,
      update: {
        act: 'edit',
        token: this.$cookies.get('token'),
        id: '',
        early_warning_day: '',
        name: '',
        number: '',
        basebarcode: '',
        spec: '',
        pym: '',
        costtype: '',
        validity: '',
        validityunit: 1,
        catid: [],
        agentid: '',
        brandid: '',
        origin: '',
        warnumber: '',
        note: '',
        morebarcode: '',
        supplierid: '',
        goodstype: '',
        unit: [],
        num: [],
        barcode: [],
        buy: [],
        sell: [],
        other: {
          0: [],
          1: [],
          2: []
        },
        market: []
      },

      mycate: [],
      mybrand: [],
      mysupply: [],

      /** 验证新增商品、修改商品表单 **/
      rules: {
        name: [ //商品名称
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
        number: [ //编号
          { required: true, message: '请输入编号', trigger: 'blur' },
          { min: 1, max: 1000, message: '长度在 1 到 1000 个字符' },
          { pattern: /^[A-Za-z0-9]+$/, message: '编号只能为字母和数字' }
        ],
        catid: [ //商品类型
          { required: true, message: '请选择商品分类', trigger: 'blur' }
        ],
        costtype: [ //成本算法
          { required: true, message: '请选择成本', trigger: 'blur' }
        ],
        validity: [
          { required: true, message: '请输入有效期', trigger: 'blur' }
        ],
        early_warning_day: [
          { required: true, message: '请输入预警天数', trigger: 'blur' }
        ],
        supplierid: [ //商品供应商
          { required: true, message: '请选择商品供应商', trigger: 'blur' }
        ],
      },
      classDialog: false,
      createClassDialog: false,
      createClassLoading: false,
      createclass: {
        act: 'addclass',
        token: this.$cookies.get('token'),
        catname: '',
        parentid: ''
      },
      classrules: {
        catname: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符' }
        ]
      },
      classlists: [],
      bigclasslists: [],
      classListLoading: false,
      updateClassDialog: false,
      updateClassLoading: false,
      updateclass: {
        act: 'editclass',
        token: this.$cookies.get('token'),
        id: '',
        catname: '',
        parentid: ''
      },
      projectData: [{
        index: 0,
        project: '基本单位'
      }, {
        index: 1,
        project: '辅助单位'
      }, {
        index: 2,
        project: '辅助单位'
      }],
      customerClass: [],
      categoryaddlistsearch: [],
      checkcode: 0, //检测基本码、条形码、一品多码在系统里是否重复（0、否 1、是）
      isnewselect: false,
      editapplyLoading: false,
      applychange: false,
      discount: [],

      brandDialog: false,
      brandquery: {
        act: 'lists',
        token: this.$cookies.get('token'),
        key: '',
        rollpage: 10, // 页大小
        p: 1
      },
      brand_total_rows: 0,
      brandquerylists: [],
      brandlistLoading: false,
      createbrandDialog: false,
      createbrandLoading: false,
      createbrand: {
        act: 'add',
        token: this.$cookies.get('token'),
        name: '',
        showthumb: '',
        showthumbbanner: '',
        thumb: '',
        bannerthumb: '',
        cate: [
          { id: 1, name: '狗狗', 'status': false },
          { id: 2, name: '猫猫', 'status': false },
          { id: 3, name: '小宠', 'status': false },
          { id: 4, name: '猫狗通用', 'status': false },
          { id: 9, name: '其它', 'status': false },
        ],
        category: [],
        showmallstatus: true,
        isshowmall: 1,
      },
      brandcategorylists: [],
      selectcategory: {
        brandcategoryid: '',
        index: '',
        type: '',
      },
      brandcategoryDialog: false,
      brandcategoryLoading: false,

      updatebrandDialog: false,
      updatebrandLoading: false,
      updatebrand: {
        id: '',
        act: 'updatebrand',
        token: this.$cookies.get('token'),
        name: '',
        thumb: '',
        bannerthumb: '',
        showthumb: '',
        showthumbbanner: '',
        cate: [
          { id: 1, name: '狗狗', 'status': false },
          { id: 2, name: '猫猫', 'status': false },
          { id: 3, name: '小宠', 'status': false },
          { id: 4, name: '猫狗通用', 'status': false },
          { id: 9, name: '其它', 'status': false },
        ],
        category: [],
        showmallstatus: true,
        isshowmall: 1,
      },
      exportlists: [],
      exportLoading: false,
      exportDialog: false,
      pushotheristrue: 0,

      thumbDialog: false,
      thumbloading: false,
      thumbs: [],
      thumbquery: {
        act: 'getthumbs',
        token: this.$cookies.get('token'),
        id: ''
      },
      kingdeelists: [],
      kingdeeDialog: false,
      kingdeeloading: false,
      customergetLoading: false,
      setkingdeequery: {
        act: 'matchkingdeeid',
        token: this.$cookies.get('token'),
        productid: '',
        kingdeeid: '',
        kingdeename: ''
      },
      iskingdee: false,
      showSynchro: false,
      syncSwitch: null,
      synchroStatus: {
        id: '',
        is_open_goods_sync: null
      }, // 是否同步状态
      showBatch: false,
      setBatch: {
        ids: '',
        early_warning_day: ''
      },
      multipleSelection: [],
      validityunitTemp: {
        1: '日',
        2: '月',
        3: '年'
      },
      batchStatus: false
    }
  },
  mounted() {
    this.getactionauth();
    this.getBrand();
    this.getList();
    this.getAllapplylists();
    this.getCategoryList();
    this.getCategoryaddList();
    this.getotherpush();
    this.checkiskingdee(); //查看当前代理商是否开启金蝶权限 
    this.getSynchroStatus()
    this.batchStatus = localStorage.getItem('batchStatus') == 'true'
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchSave() {
      if (!this.setBatch.early_warning_day || this.setBatch.early_warning_day < 1) {
        this.$message({
          type: 'error',
          message: '预警天数不能小于1天'
        });
        return
      }
      const ids = this.multipleSelection.map(item => item.id).join(',');
      this.setBatch.ids = ids;
      var resource = this.$resource(this.url);
      resource.save({
        act: 'batch_settings_warning_day',
        token: this.$cookies.get('token'),
        ...this.setBatch
      }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.$message({
            message: '设置成功',
            type: 'success'
          });
          this.showBatch = false
          this.setBatch = {
            ids: '',
            early_warning_day: ''
          }
        }
      })

    },
    validateEarlyWarningRange() {
      // 转换为数字，空值视为null
      const start = this.query.start_early_warning_day === '' ? null : Number(this.query.start_early_warning_day);
      const end = this.query.end_early_warning_day === '' ? null : Number(this.query.end_early_warning_day);
      console.log(start, end, 'validateEarlyWarningRange')
      if(!start || !end) {
        return
      }
      
      // 验证是否为有效数字
      if (start !== null && (isNaN(start) || start < 0)) {
        this.$message.warning('起始天数必须为非负数字');
        this.query.start_early_warning_day = '';
        return;
      }
      
      if (end !== null && (isNaN(end) || end < 0)) {
        this.$message.warning('结束天数必须为非负数字');
        this.query.end_early_warning_day = '';
        return;
      }
      
      // 仅当两个值均存在且有效时，验证范围
      if (start !== null && end !== null) {
        if (start > end) {
          // 交换值（确保值为字符串，与输入框绑定一致）
          const tempStart = this.query.start_early_warning_day;
          const tempEnd = this.query.end_early_warning_day;
          this.query.start_early_warning_day = tempEnd;
          this.query.end_early_warning_day = tempStart;
          this.$message.warning('起始天数不能大于结束天数，已自动调整');
        }
      }
    },
    // 同步线上商城
    synchro(val) {
      console.log(val)
      var resource = this.$resource(this.url);
      resource.save({
        act: 'open_sync_switch',
        token: this.$cookies.get('token'),
        is_true: val
      }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.$message({
            message: '设置成功',
            type: 'success'
          });
        }
      })
    },
    // 查询同步状态
    getSynchroStatus() {
      var resource = this.$resource(this.url);
      resource.save({ act: 'open_sync_switch', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          console.log(result, '******************')
          this.synchroStatus = result
        }
      })
    },

    /** 获取操作功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    /** 查看当前代理商是否开启了金蝶权限 **/
    checkiskingdee() {
      var resource = this.$resource(this.GLOBAL.domain + "kingdee/index");
      resource.save({ act: 'isopenkingdee', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.iskingdee = result.iskingdee;
        }
      }).catch((res) => {

      });
    },

    /** 跳转至合作代理商 **/
    getsplitagents() {
      this.$emit('listenchild', { name: '我的合作代理商', url: 'Splitagent' });
    },

    /** 获取是否有合作代理商（可以将货品发布到合作代理商的商城做销售） **/
    getotherpush() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'getispushagent', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.pushotheristrue = result.istrue;
        }
      }).catch((res) => {

      });
    },

    /** 获取有效期单位 **/
    checkaddvalidity() {
      this.validityDialog = true;
    },


    /** 选择有效期单位 **/
    ensurevalidity(obj) {
      this.validityunitname = obj.name;
      this.create.validityunit = obj.id;
      this.update.validityunit = obj.id;
      this.validityDialog = false;
    },


    /** 获取拼音码 **/
    getCode() {
      var resource = this.$resource(this.GLOBAL.domain + "Pinyin/index",);
      resource.query({ str: this.create.name, token: this.$cookies.get('token') }).then((res) => {
        this.create.pym = res.data.Message;
      });
    },


    /** 修改商品获取拼音码 **/
    updategetCode() {
      var resource = this.$resource(this.GLOBAL.domain + "Pinyin/index",);
      resource.query({ str: this.update.name, token: this.$cookies.get('token') }).then((res) => {
        this.update.pym = res.data.Message;
      });
    },


    /** 基本条形码 **/
    addsetBarcode(id) {
      if (id == 0) var code = this.create.basebarcode;
      if (id > 0) var code = this.update.basebarcode;

      if (code != '') {
        //请求后台服务
        var resource = this.$resource(this.url);
        resource.query({ act: 'checkcodeequal', token: this.$cookies.get('token'), code: code, id: id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            var result = Base64.decode(res.data.Data);

            if (result == 1) { //检测到系统里有重复的基本码提示是否添加
              var msg = "基本条码：" + code + "在系统中已经存在，是否继续添加？";
              this.$confirm(msg, '提示', { type: 'warning' }).then(() => {
                if (id == 0) this.create.barcode.splice(0, 1, this.create.basebarcode);
                if (id > 0) this.update.barcode.splice(0, 1, this.update.basebarcode);
              }).catch(() => {
                if (id == 0) {
                  this.create.basebarcode = '';
                  this.create.barcode.splice(0, 1, this.create.basebarcode);
                } else {
                  this.update.basebarcode = '';
                  this.update.barcode.splice(0, 1, this.update.basebarcode);
                }

              });
            } else { //系统里没有重复的基本码
              if (id == 0) this.create.barcode.splice(0, 1, this.create.basebarcode);
              if (id > 0) this.update.barcode.splice(0, 1, this.update.basebarcode);
            }

          }
        }).catch((res) => {
          this.$message.error("获取数据失败，请稍后重试");
        });

      } else {
        if (id == 0) this.create.barcode.splice(0, 1, this.create.basebarcode);
        if (id > 0) this.update.barcode.splice(0, 1, this.update.basebarcode);
      }
    },


    /** 添加条形码检测 **/
    addunitcode(code, index, id) {
      if (code != '') {
        //请求后台服务
        var resource = this.$resource(this.url);
        resource.query({ act: 'checkunitcodeequal', token: this.$cookies.get('token'), code: code, id: id }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            var result = Base64.decode(res.data.Data);
            if (result == 1) { //检测到系统里有重复的基本码提示是否添加
              var msg = "条形码：" + code + "在系统中已经存在，是否继续添加？";
              this.$confirm(msg, '提示', { type: 'warning' }).then(() => {

              }).catch(() => {
                if (id == 0) this.create.barcode.splice(index, 1, '');
                if (id > 0) this.update.barcode.splice(index, 1, '');
              });
            } else { //系统里没有重复的基本码

            }

          }
        }).catch((res) => {
          this.$message.error("获取数据失败，请稍后重试");
        });

      } else {
        if (id == 0) this.create.barcode.splice(index, 1, '');
        if (id > 0) this.update.barcode.splice(index, 1, '');
      }
    },


    /** 重置表单 **/
    reset() {
      this.$refs.create.resetFields();
      this.create.unit = [];
      this.create.num = [];
      this.create.barcode = [];
      this.create.buy = [];
      this.create.sell = [];
      this.create.market = [];
      this.create.morebarcode = '';
      this.create.other[0] = [];
      this.create.other[1] = [];
      this.create.other[2] = [];
    },


    /** 新增商品对话框 **/
    addDialog() {
      this.createDialog = true;
      this.create.num.splice(0, 1, 1);
      this.getBrand();
      this.getCustomerClass();
    },


    /** 根据条形码从大数据库中获取信息 **/
    getBarcodeInfo() {
      var resource = this.$resource(this.GLOBAL.domain + "Product/index");
      resource.query({ act: 'getbarcodeinfo', token: this.$cookies.get('token'), barcode: this.create.basebarcode }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
        } else {
          var info = JSON.parse(Base64.decode(res.data.Data));
          if (info.name != '' && info.name != null) this.create.name = info.name
          if (info.spec != '' && info.spec != null) this.create.spec = info.spec
          if (info.brandid != '' && info.brandid != null) this.create.brandid = info.brandid
          if (info.unit != '' && info.unit != null) this.create.unit.splice(0, 1, info.unit)
        }
      }).catch((res) => {

      });
    },


    /** 获取品牌 **/
    getBrand() {
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var _this = this;
          var thumb = '';
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取分类列表 **/
    getCategoryList() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'getcatelist', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.categorylistsearch = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 添加分类展示类表 **/
    getCategoryaddList() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'getaddcatelist', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.categoryaddlistsearch = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 获取用户分组 **/
    getCustomerClass() {
      var resource = this.$resource(this.GLOBAL.domain + "Customer/index");
      resource.query({ act: 'getclass', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.customerClass = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 新增商品 **/
    createSave() {
      if (this.create.unit[1] != '' && this.create.num[1] != '' && this.create.unit[1] != null && this.create.num[1] != null) {
        this.$confirm('确定设置辅助单位 [ ' + this.create.num[1] + this.create.unit[0] + ' = ' + this.create.num[0] + this.create.unit[1] + ' ] 吗？', '提示', { type: 'warning' }).then(() => {
          this.addSave();
        }).catch(() => {
          this.$message.info('已取消操作!');
        });
      } else {
        this.addSave();
      }
    },


    /** 保存新增商品 **/
    addSave() {
      //校验数据有效性
      this.$refs.create.validate((valid) => {
        if (valid) {
          this.createLoading = true;
          var resource = this.$resource(this.url);
          resource.save(this.create).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.createLoading = false;
            } else {
              this.$message.success(res.data.Message);
              this.createDialog = false;
              this.createLoading = false;
              this.reset();
              this.getList();
            }
          }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.createDialog = false;
            this.createLoading = false;
          });
        } else {
          return false;
        }
      });
    },


    /** 商品信息列表 **/
    getList() {
      if (this.isnewselect == true) {
        this.query.p = 1;
        this.query.rollpage = 10;
      }

      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows = parseInt(res.data.count);
          this.listLoading = false;

        }

        if (this.isnewselect == true) this.isnewselect = false;
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
        if (this.isnewselect == true) this.isnewselect = false;
      });
    },
    pageSizeChange(val) {
      this.query.rollpage = val;
      this.getList();
    },
    pageCurrentChange(val) {
      this.query.p = val;
      this.getList();
    },
    pageSizeapplyChange(val) {
      this.applyquery.rollpage = val;
      this.getApplylists();
    },
    pageapplyCurrentChange(val) {
      this.applyquery.p = val;
      this.getApplylists();
    },


    /** 编辑商品信息 **/
    editCurrent(item) {
      this.updateDialog = true;
      this.getBrand();
      this.getCustomerClass();

      //向服务端请求数据
      var resource = this.$resource(this.url);
      resource.save({ act: 'getinfo', id: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.update = JSON.parse(Base64.decode(res.data.Data));
          console.log("🚀 ~ resource.save ~ this.update:", this.update)
          
          this.update.act = 'edit';
          this.update.token = this.$cookies.get('token');
          if (this.update.pym == '' || this.update.pym == null) this.updategetCode();

          if (this.update.validityunit == 1) {
            this.create.validityunit = 1;
            this.validityunitname = '日';
          } else if (this.update.validityunit == 2) {
            this.create.validityunit = 2;
            this.validityunitname = '月';
          } else {
            this.create.validityunit = 3;
            this.validityunitname = '年';
          }

        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 更新商品信息 **/
    updateSave() {
      //校验数据有效性
      this.$refs.update.validate((valid) => {
        if (valid) {
          this.updateLoading = true;
          var resource = this.$resource(this.url);
          resource.save(this.update).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.updateLoading = false;
            } else {
              this.$message.success(res.data.Message);
              this.updateDialog = false;
              this.updateLoading = false;
              this.getList();
            }
          }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.updateDialog = false;
            this.updateLoading = false;
          });
        } else {
          return false;
        }
      });
    },


    /** 删除商品信息 **/
    delCurrent(item) {
      this.$confirm('此操作将永久删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'del', id: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('成功删除了' + item.name + '!');
            this.getList();
          }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },


    /** 重置分类表单 **/
    resetClass() {
      this.$refs.createclass.resetFields();
    },


    /** 分类列表 **/
    showClassDialog() {
      this.$emit('listenchild', { name: '商品分类管理', url: 'Productcate' });
      //this.classDialog=true;
      //this.getClassList();
    },


    /** 显示新增分类框 **/
    addClassDialog() {
      this.createClassDialog = true;
      this.getBigClassList();
    },


    /** 新增分类 **/
    createClassSave() {
      //校验数据有效性
      this.$refs.createclass.validate((valid) => {
        if (valid) {
          this.createClassLoading = true;
          var resource = this.$resource(this.url);
          resource.save(this.createclass).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.createClassLoading = false;
            } else {
              this.$message.success(res.data.Message);
              this.resetClass();
              this.getClassList(); //更新分类列表
              this.getCategoryList(); //更新分类搜索
              this.getCategoryaddList(); //更新选择分类
              this.createClassDialog = false;
              this.createClassLoading = false;
            }
          }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.createClassDialog = false;
            this.createClassLoading = false;
          });
        } else {
          return false;
        }
      });
    },


    /** 分类列表 **/
    getClassList() {
      this.classListLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getclass', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.classListLoading = false;
        } else {
          this.classlists = JSON.parse(Base64.decode(res.data.Data));
          this.classListLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.classListLoading = false;
      });
    },


    /** 取出所有大类 **/
    getBigClassList() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'getbigclass', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.bigclasslists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 显示编辑分类框 **/
    editClassDialog(item) {
      this.updateClassDialog = true;
      this.getBigClassList();
      this.updateclass.id = item.id;
      this.updateclass.catname = item.catname;
      this.updateclass.parentid = item.parentid;
    },


    /** 编辑分类的保存 **/
    updateClassSave() {
      //校验数据有效性
      this.$refs.updateclass.validate((valid) => {
        if (valid) {
          this.updateClassLoading = true;
          var resource = this.$resource(this.url);
          resource.save(this.updateclass).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.updateClassLoading = false;
            } else {
              this.$message.success(res.data.Message);
              this.updateClassDialog = false;
              this.updateClassLoading = false;
              this.getClassList();
              this.getCategoryaddList(); //更新选择分类
            }
          }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.createClassDialog = false;
            this.createClassLoading = false;
          });
        } else {
          return false;
        }
      });
    },


    /** 删除 **/
    delClass(item) {
      this.$confirm('此操作将永久删除 ' + item.catname + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'delclass', id: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('成功删除了' + item.catname + '!');
            this.getClassList(); //更新分类列表
            this.getCategoryList(); //更新搜索分类
          }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },


    /** 供应商列表 **/
    showSlDialog() {
      this.$emit('listenchild', { name: '商品供应商管理', url: 'Productsupply' });
      //this.showSupplierDialog=true;
      //this.getApplylists();
    },


    /** 获取供应商列表 **/
    getApplylists() {
      if (this.applychange == 'true') {
        this.applyquery.p = 1;
        this.applyquery.rollpage = 10;
      }

      this.ApplyLoading = true;
      var resource = this.$resource(this.applyquery.url);
      resource.query(this.applyquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login');
            this.ApplyLoading = false;
          }
          this.$message.error(res.data.Message);
          this.ApplyLoading = false;
        } else {
          this.applylists = JSON.parse(Base64.decode(res.data.Data));
          this.apply_total_rows = parseInt(res.data.count);
          this.ApplyLoading = false;
        }

        if (this.applychange == 'true') this.applychange = false;
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.ApplyLoading = false;
      });
    },


    /** 获取全部列表 **/
    getAllapplylists() {
      var resource = this.$resource(this.allapplyquery.url);
      resource.query(this.allapplyquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login');
          }
          this.$message.error(res.data.Message);;
        } else {
          this.allapplylists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 添加供应商名称 **/
    addsupplySave() {
      this.updatesuppleraddLoading = true;
      var resource = this.$resource(this.applyquery.url);
      resource.query(this.createapply).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login');
            this.updatesuppleraddLoading = false;
            this.showaddSupplierDialog = false;
          }
          this.$message.error(res.data.Message);
          this.updatesuppleraddLoading = false;
          this.showaddSupplierDialog = false;
        } else {
          this.$message.success('添加供应商：' + this.createapply.apply_name + '成功!');
          this.updatesuppleraddLoading = false;
          this.showaddSupplierDialog = false;
          this.getApplylists();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.updatesuppleraddLoading = false;
        this.showaddSupplierDialog = false;
      });
    },


    /** 编译供应商信息 **/
    editApplyCurrent(obj) {
      this.showeditSupplierDialog = true;
      this.editapplyLoading = true;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getapplyinfo', token: this.$cookies.get('token'), id: obj.id }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);
          this.editapplyLoading = false;
        } else {
          var data = JSON.parse(Base64.decode(res.data.Data));
          this.editapply.id = data.id;
          this.editapply.apply_name = data.apply_name;
          this.editapply.company = data.company;
          this.editapply.rate = data.rate;
          this.editapply.rateid = data.rateid;
          this.editapply.bank = data.bank;
          this.editapply.banknumber = data.banknumber;
          this.editapply.truename = data.truename;
          this.editapply.phone = data.phone;
          this.editapply.address = data.address;
          this.editapplyLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.editapplyLoading = false;
      });
    },


    /** 保存编辑供应商信息 **/
    editsupplySave() {
      this.updatesupplereditLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.editapply).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login');
            this.updatesupplereditLoading = false;
            this.showaddSupplierDialog = false;
          }
          this.$message.error(res.data.Message);
          this.updatesupplereditLoading = false;
          this.showeditSupplierDialog = false;
        } else {
          this.$message.success('修改供应商信息成功!');
          this.updatesupplereditLoading = false;
          this.showeditSupplierDialog = false;
          this.getApplylists();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.updatesupplereditLoading = false;
        this.showeditSupplierDialog = false;
      });
    },


    //删除供应商信息
    delApplyCurrent(obj) {
      if (obj.snumbers > 0) {
        this.$message.error("该供应商目前关联有" + obj.snumbers + "个商品，删除该供应商前请先将关联的商品删除！");
        return false;
      }

      this.$confirm('此操作将永久删除 ' + obj.apply_name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.url);
        resource.save({ act: 'delapply', id: obj.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('成功删除了' + obj.apply_name + '!');
            this.getApplylists();
          }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },


    /** 联动更新纵列订单价格 **/
    changecolprice(index, keyvalue, sort, type) {

      var _this = this;
      var price;
      var base_price;

      var number = type == 'create' ? this.create.num[index] : this.update.num[index]; //获取当前行的单位关系
      if (keyvalue == 'buy') type == 'create' ? price = this.create.buy[index] : price = this.update.buy[index];
      if (keyvalue == 'sell') type == 'create' ? price = this.create.sell[index] : price = this.update.sell[index];
      if (keyvalue == 'market') type == 'create' ? price = this.create.market[index] : price = this.update.market[index];
      if (keyvalue == 'other') type == 'create' ? price = this.create.other[index][sort] : price = this.update.other[index][sort];
      if (number == null || number == '' || price == null || price == 0) return false;

      //联动修改价格
      base_price = price / number;
      if (keyvalue != 'other' && type == 'create') {
        this.create.num.forEach(function (e, index) {
          if (keyvalue == 'buy' && type == 'create' && (e != null || e != '') && (_this.create.buy[index] == null || _this.create.buy[index] == '')) _this.$set(_this.create.buy, index, (base_price * e).toFixed(2));
          if (keyvalue == 'sell' && type == 'create' && (e != null || e != '') && (_this.create.sell[index] == null || _this.create.sell[index] == '')) _this.$set(_this.create.sell, index, (base_price * e).toFixed(2));
          if (keyvalue == 'market' && type == 'create' && (e != null || e != '') && (_this.create.market[index] == null || _this.create.market[index] == '')) _this.$set(_this.create.market, index, (base_price * e).toFixed(2));
        });
      }
      if (keyvalue != 'other' && type == 'update') {
        this.update.num.forEach(function (e, index) {
          if (keyvalue == 'buy' && type == 'update' && e != '' && (_this.update.buy[index] == null || _this.update.buy[index] == '')) _this.$set(_this.update.buy, index, (base_price * e).toFixed(2));
          if (keyvalue == 'sell' && type == 'update' && e != '' && (_this.update.sell[index] == null || _this.update.sell[index] == '')) _this.$set(_this.update.sell, index, (base_price * e).toFixed(2));
          if (keyvalue == 'market' && type == 'update' && e != '' && (_this.update.market[index] == null || _this.update.market[index] == '')) _this.$set(_this.update.market, index, (base_price * e).toFixed(2));
        });
      }

      if (keyvalue == 'other' && type == 'create') {
        this.create.num.forEach(function (e, index) {
          if ((e != null || e != '') && (_this.create.other[index][sort] == null || _this.create.other[index][sort] == ''))
            _this.$set(_this.create.other[index], sort, (base_price * e).toFixed(2));
        });
      }

      if (keyvalue == 'other' && type == 'update') {
        this.update.num.forEach(function (e, index) {
          if (e != '' && (_this.update.other[index][sort] == null || _this.update.other[index][sort] == ''))
            _this.$set(_this.update.other[index], sort, (base_price * e).toFixed(2));
        });
      }

    },

    /** 联动修改所有价格 **/
    changeprice(i, type) {
      var _this = this;
      if (type == 'create') {
        this.create.num.forEach(function (e, index) {
          //重置进货价
          _this.create.buy.forEach(function (b, i) {
            if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'buy', -1, 'create');
          });
          //重置批发价
          _this.create.sell.forEach(function (b, i) {
            if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'sell', -1, 'create');
          });
          //重置市场价
          _this.create.market.forEach(function (b, i) {
            if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'market', -1, 'create');
          });
          //重置其它价格
          _this.create.other[index].forEach(function (b, i) {
            if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'other', i, 'create');
          });
        });
      } else {
        this.update.num.forEach(function (e, index) {
          //重置进货价
          _this.update.buy.forEach(function (b, i) {
            if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'buy', -1, 'update');
          });
          //重置批发价
          _this.update.sell.forEach(function (b, i) {
            if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'sell', -1, 'update');
          });
          //重置市场价
          _this.update.market.forEach(function (b, i) {
            if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'market', -1, 'update');
          });
          //重置其它价格
          _this.update.other[index].forEach(function (b, i) {
            if ((e != null || e != '') && (b != null || b != '')) _this.changecolprice(index, 'other', i, 'update');
          });
        });
      }
    },


    /** 批量新增商品 **/
    showSlmore() {
      this.showSlmoreDialog = true;
    },


    /** 下载模板 **/
    downmodel() {
      location.href = this.GLOBAL.domain + "ChangeFile/getexport";
    },


    /** 导入文件 **/
    uploadinfos() {
      document.getElementById("fileupload").click();
    },


    /** 删除导入商品信息 **/
    delinfos(index) {
      this.productsmore.splice(index, 1);
    },

    mypageSizeChange(val) {
      this.mycatequery.rollpage = val;
      this.mygoodscate();
    },
    mypageCurrentChange(val) {
      this.mycatequery.p = val;
      this.mygoodscate();
    },

    mybrandpageSizeChange(val) {
      this.mybrandquery.rollpage = val;
      this.mygoodsbrand();
    },
    mybrandpageCurrentChange(val) {
      this.mybrandquery.p = val;
      this.mygoodsbrand();
    },
    mysupplypageSizeChange(val) {
      this.mysupplyquery.rollpage = val;
      this.mygoodssupply();
    },
    mysupplypageCurrentChange(val) {
      this.mysupplyquery.p = val;
      this.mygoodssupply();
    },


    /** 获取我的商品信息分类列表 **/
    mygoodscate() {
      this.myclassDialog = true;
      this.myclassLoading = true;
      var resource = this.$resource(this.mycatequery.url);
      resource.query(this.mycatequery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.myclassDialog = false;
          this.myclassLoading = false;
        } else {
          this.mycate = JSON.parse(Base64.decode(res.data.Data));
          this.my_cate_total_rows = parseInt(res.data.count);
          this.myclassLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.myclassLoading = false;
      });
    },


    /** 获取我的商品品牌列表 **/
    mygoodsbrand() {
      this.mybrandDialog = true;
      this.mybrandLoading = true;
      var resource = this.$resource(this.mybrandquery.url);
      resource.query(this.mybrandquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.mybrandDialog = false;
          this.mybrandLoading = false;
        } else {
          this.mybrand = JSON.parse(Base64.decode(res.data.Data));
          this.my_brand_total_rows = parseInt(res.data.count);
          this.mybrandLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.mybrandLoading = false;
      });
    },


    /** 获取我的商品供应商信息列表 **/
    mygoodssupply() {
      this.mysupplyDialog = true;
      this.mysupplyLoading = true;
      var resource = this.$resource(this.mysupplyquery.url);
      resource.query(this.mysupplyquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.mysupplyDialog = false;
          this.mysupplyLoading = false;
        } else {
          this.mysupply = JSON.parse(Base64.decode(res.data.Data));
          this.my_supply_total_rows = parseInt(res.data.count);
          this.mysupplyLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.mysupplyLoading = false;
      });
    },


    /** 保存批量导入商品 **/
    inputinfosSave() {
      this.saveexcelLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'saveinputgoods', token: this.$cookies.get('token'), infos: this.productsmore }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.saveexcelLoading = false;
        } else {
          this.$message.success('商品信息导入成功！');
          this.saveexcelLoading = false;
          this.showSlmoreDialog = false;
          this.productsmore = [];
          this.getList();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.saveexcelLoading = false;
      });
    },

    /************** 导入excel表格数据 **************/
    importfile(obj) {
      let _this = this;
      let inputDOM = this.$refs.inputer;
      // 通过DOM取文件数据
      this.file = event.currentTarget.files[0];
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;
      var outdata;
      var reader = new FileReader();
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
          var XLSX = require('xlsx');
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), { type: 'base64' });
          } else {
            wb = XLSX.read(binary, { type: 'binary' });
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
          //清空输入框的文件值，避免下次change事件失效
          document.getElementById('fileupload').value = null;

          //提交数据到后台
          _this.uploadgoodsLoading = true;
          var resource = _this.$resource(_this.url);
          resource.save({ act: 'inputinfos', infos: outdata, token: _this.$cookies.get('token') }).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') this.$router.push('/login')
              _this.uploadgoodsLoading = false;
              _this.$message({
                dangerouslyUseHTMLString: true,
                type: 'error',
                message: '<span style="line-height:20px">' + res.data.Message + '</span>',
              });
            } else {
              _this.productsmore = JSON.parse(Base64.decode(res.data.Data));
              _this.uploadgoodsLoading = false;
              _this.$message.success('导入商品信息成功!');
            }
          }).catch((res) => {
            _this.uploadgoodsLoading = false;
            _this.$message.error(this.GLOBAL.errortext);
          });

        }
        reader.readAsArrayBuffer(f);
      }

      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }

    },
    /************* 导入excel表格数据 *****************/


    //开启/关闭折扣按钮
    changediscount(index, obj) {
      var isdiscount = 0;
      this.discount[index] ? isdiscount = 1 : isdiscount = 0;

      var resource = this.$resource(this.url);
      resource.save({ act: 'changerebate', id: obj.id, isdiscount: isdiscount, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        }
      }).catch((res) => {
        //this.$message.error(this.GLOBAL.errortext);
      });
    },


    //获取品牌列表
    showgoodsbrand() {
      this.$emit('listenchild', { name: '品牌管理', url: 'Productbrand' });
      //this.brandDialog=true;
      //this.getbrandlists();
    },

    //信息列表
    getbrandlists() {
      this.brandlistLoading = true;
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query(this.brandquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.brandlistLoading = false;
        } else {
          var _this = this;
          var thumb = '';
          this.brandquerylists = JSON.parse(Base64.decode(res.data.Data));
          this.brandquerylists.forEach(function (e, index) {
            e.thumb != '' && e.thumb != null ? thumb = _this.GLOBAL.staticUrl + e.thumb : thumb = '';
            _this.brandquerylists[index].thumb = thumb;
          });

          this.brand_total_rows = parseInt(res.data.count);
          this.brandlistLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.brandlistLoading = false;
      });
    },

    brandpageSizeChange(val) {
      this.brandquery.rollpage = val;
      this.getbrandlists();
    },
    brandpageCurrentChange(val) {
      this.brandquery.p = val;
      this.getbrandlists();
    },

    delbrandCurrent(item) {
      this.$confirm('此操作将永久删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
        // 向请求服务端删除
        var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
        resource.save({ act: 'del', id: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.$message.success('成功删除了' + item.name + '!');
            this.getbrandlists();
          }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });
      }).catch(() => {
        this.$message.info('已取消操作!');
      });
    },

    createbrandSave() {
      this.createbrandLoading = true;
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.save(this.createbrand).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.createbrandLoading = false;
        } else {
          this.$message.success(res.data.Message);
          this.createbrandDialog = false;
          this.createbrandLoading = false;
          this.createbrand.name = '';
          this.getbrandlists();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.createbrandDialog = false;
        this.createbrandLoading = false;
      });
    },


    //新增品牌信息
    addcreatebrandinfo() {
      var _this = this;
      this.createbrand.name = '';
      this.createbrand.showthumb = '';
      this.createbrand.showthumbbanner = '';
      this.createbrand.thumb = '';
      this.createbrand.bannerthumb = '';
      this.createbrand.category = [];
      this.selectcategory.type = 'create';
      this.createbrand.cate.forEach(function (e, index) {
        _this.createbrand.cate[index].status = false;
      });
      this.createbrandDialog = true;
    },


    //上传品牌缩略图
    filecreateminiChange(el, type) {
      var resource = this.$resource(this.GLOBAL.uploadUrl);
      var formData = new FormData();
      formData.append('checktype', 'brandmini');
      formData.append('file', el.target.files[0]);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
      resource.save(formData).then((res) => {
        var data = JSON.parse(Base64.decode(res.body.Data));
        if (data.Result > 0) {
          this.$message.error(data.msg);
        } else {
          if (type == 'create') {
            this.createbrand.showthumb = this.GLOBAL.staticUrl + data.imgsrc;
            this.createbrand.thumb = data.imgsrc;
          } else {
            this.updatebrand.showthumb = this.GLOBAL.staticUrl + data.imgsrc;
            this.updatebrand.thumb = data.imgsrc;
          }
          el.target.value = '';
        }
      }).catch((res) => {
      });
    },

    //上传品牌banner图
    filecreateChange(el, type) {
      var resource = this.$resource(this.GLOBAL.uploadUrl);
      var formData = new FormData();
      formData.append('file', el.target.files[0]);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
      resource.save(formData).then((res) => {
        var data = JSON.parse(Base64.decode(res.body.Data));
        if (data.Result > 0) {
          this.$message.error(data.msg);
        } else {
          if (type == 'create') {
            this.createbrand.showthumbbanner = this.GLOBAL.staticUrl + data.imgsrc;
            this.createbrand.bannerthumb = data.imgsrc;
          } else {
            this.updatebrand.showthumbbanner = this.GLOBAL.staticUrl + data.imgsrc;
            this.updatebrand.bannerthumb = data.imgsrc;
          }
          el.target.value = '';
        }
      }).catch((res) => {

      });
    },



    //获取品牌信息
    editbrandCurrent(item) {
      this.updatebrand.name = '';
      this.updatebrand.showthumb = '';
      this.updatebrand.showthumbbanner = '';
      this.updatebrand.thumb = '';
      this.updatebrand.bannerthumb = '';
      this.updatebrand.category = [];

      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.save({ act: 'getbrandinfos', id: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          var _this = this;
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.updatebrand.id = result.id;
          this.updatebrand.name = result.name;
          this.updatebrand.thumb = result.thumb;
          this.updatebrand.bannerthumb = result.bannerthumb;
          this.updatebrand.showthumb = this.GLOBAL.staticUrl + result.thumb;
          this.updatebrand.showthumbbanner = this.GLOBAL.staticUrl + result.bannerthumb;
          this.updatebrand.isshowmall = result.isshowmall;
          this.updatebrand.showmallstatus = result.isshowmall == 1 ? true : false;

          result.category.forEach(function (e, index) {
            _this.updatebrand.category.push({ pcatid: e.pcatid, scatid: e.scatid, catname: e.catname });
          });

          this.updatebrand.cate.forEach(function (e, i) {
            _this.updatebrand.cate[i].status = false;
            result.cate.forEach(function (ee, ii) {
              if (e.id == ee) _this.updatebrand.cate[i].status = true;
            });
          });

          this.selectcategory.type = 'update';
          this.updatebrandDialog = true;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    //保存品牌信息
    updatebrandSave() {
      this.updatebrandLoading = true;
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.save(this.updatebrand).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.updatebrandLoading = false;
        } else {
          this.$message.success("编辑品牌信息成功！");
          this.updatebrandLoading = false;
          this.updatebrandDialog = false;
          this.getbrandlists();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.updatebrandLoading = false;
      });
    },

    //新增品牌绑定分类条数
    addbrandCurrent() {
      var param = { pcatid: 0, scatid: 0, catname: '' };
      this.createbrand.category.push(param);
    },
    //编辑新增品牌绑定分类条数
    updatebrandCurrent() {
      var param = { pcatid: 0, scatid: 0, catname: '' };
      this.updatebrand.category.push(param);
    },
    //删除单条品牌分类信息
    delbrandcate(id) {
      this.createbrand.category.splice(id, 1);
    },
    //编辑删除单条品牌分类信息
    delupdatebrandcate(id) {
      this.updatebrand.category.splice(id, 1);
    },

    //搜索分类信息
    addbrandcate(item, index, type) {
      var id = item.scatid;
      var ids = [];

      if (type == 'create') {
        this.createbrand.category.forEach(function (e, i) {
          if (e.scatid != id && e.scatid != 0) ids.push(e.scatid)
        });
      } else {
        this.updatebrand.category.forEach(function (e, i) {
          if (e.scatid != id && e.scatid != 0) ids.push(e.scatid)
        });
      }

      this.selectcategory.index = index;
      this.selectcategory.brandcategoryid = [];
      this.brandcategoryDialog = true;
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.save({ act: 'brandcategorylists', token: this.$cookies.get('token'), ids: ids }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.brandcategorylists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    //保存选择的分类
    brandcategorysave() {
      var _this = this;
      var ids = this.selectcategory.brandcategoryid;
      if (ids == '') { this.$message.error("请选择要绑定的分类"); return false; }

      var pcatid = ids[0];
      var scatid = ids[1];
      var index = this.selectcategory.index;

      if (this.selectcategory.type == 'create') {
        this.createbrand.category[index].pcatid = pcatid;
        this.createbrand.category[index].scatid = scatid;

        this.brandcategoryLoading = true;
        this.brandcategorylists.forEach(function (e, i) {
          if (e.value == ids[0]) {
            e.children.forEach(function (ee, ii) {
              if (ee.value == ids[1]) {
                _this.createbrand.category[index].catname = ee.label;
              }
            });
          }
        });

      } else {
        this.updatebrand.category[index].pcatid = pcatid;
        this.updatebrand.category[index].scatid = scatid;

        this.brandcategoryLoading = true;
        this.brandcategorylists.forEach(function (e, i) {
          if (e.value == ids[0]) {
            e.children.forEach(function (ee, ii) {
              if (ee.value == ids[1]) {
                _this.updatebrand.category[index].catname = ee.label;
              }
            });
          }
        });

      }

      this.brandcategoryLoading = false;
      this.brandcategoryDialog = false;
    },

    //开启/关闭品牌连同品牌下所属的线上商城商品是否展示
    changeshowmall(type) {
      if (type == 'create') {
        if (this.createbrand.isshowmall == 1) {
          this.$confirm('温馨提示：该操作会关闭该品牌以及该 品牌所属的线上商城商品信息的展示，您确定要执行该操作吗？', '提示', { type: 'warning' }).then(() => {
            this.createbrand.isshowmall = 0;
            this.createbrand.showmallstatus = false;
          }).catch(() => {
            this.createbrand.isshowmall = 1;
            this.createbrand.showmallstatus = true;
          });

        } else {
          this.createbrand.isshowmall = 1;
          this.createbrand.showmallstatus = true;
        }

      } else {
        if (this.updatebrand.isshowmall == 1) {
          this.$confirm('温馨提示：该操作会关闭该品牌在进货商城中的展示，并下架进货商城里该品牌所属的商品，您确定要执行该操作吗？', '提示', { type: 'warning' }).then(() => {
            this.updatebrand.isshowmall = 0;
            this.updatebrand.showmallstatus = false;
          }).catch(() => {
            this.updatebrand.isshowmall = 1;
            this.updatebrand.showmallstatus = true;
          });

        } else {
          this.updatebrand.isshowmall = 1;
          this.updatebrand.showmallstatus = true;
        }

      }
    },


    //导出商品信息
    exportdata() {
      this.exportLoading = true;
      this.exportDialog = true;
      var resource = this.$resource(this.GLOBAL.exportUrl + 'Product/index');
      resource.save({ act: 'getexportdata', token: this.$cookies.get('token'), brandid: this.query.brandid, catid: this.query.catid, key: this.query.key, isexport: 1 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.exportLoading = false;
        } else {
          this.exportLoading = false;
          this.exportlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.exportLoading = false;
      });
    },

    /** 确认导出订单信息 **/
    sureoutput() {
      require.ensure([], () => {
        var { export_json_to_excel } = require('../../vendor/Export2Excel');
        var tHeader = ['商品名称', '编号', '基本条码', '规格', '箱装规格', '成本算法', '有效期（天）', '商品分类', '品牌', '供应商', '单位名称', '进货价', '批发价', '零售价'];
        var filterVal = ['name', 'number', 'basebarcode', 'spec', 'box_gauge', 'costtype', 'realvalidity', 'catname', 'brandname', 'applyname', 'unit', 'buy', 'sell', 'market'];

        var list = this.exportlists;
        var data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '商品信息');
        this.exportDialog = false;
      })
    },

    //导出表格数据
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },

    //获取商品图片信息
    editthumbs(obj) {
      this.thumbquery.id = obj.id;
      this.thumbs = [];
      this.thumbDialog = true;
      this.thumbloading = true;

      var resource = this.$resource(this.url);
      resource.save(this.thumbquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.thumbloading = false;
        } else {
          this.thumbs = JSON.parse(Base64.decode(res.data.Data));
          this.thumbloading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.thumbloading = false;
      });
    },

    //点击获取活动宣传图
    getadimga() {
      document.getElementById('adimg').click();
    },

    //上传图片
    getadimgb(obj) {
      this.thumbloading = true;
      var file = obj.target.files[0]; //获取文件信息
      var formData = new FormData();
      formData.append('file', file);
      formData.append('sys_type', 'cz');
      formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
      var resource = this.$resource(this.GLOBAL.uploadUrl);
      resource.save(formData).then((res) => {
        var data = JSON.parse(Base64.decode(res.body.Data));
        if (data.Result > 0) {
          this.$message.error(data.msg);
        } else {
          this.thumbs.push({ url: data.imgsrc, isdefault: 0 });
          obj.target.value = '';
        }
        this.thumbloading = false;
      }).catch((res) => {
        this.thumbloading = false;
      });
    },

    //删除图片
    closethumb(index) {
      this.$delete(this.thumbs, index);
    },

    //选择封面图片
    selectdefaultthumb(index) {
      this.thumbs.forEach(function (item, i) {
        index == i ? item.isdefault = 1 : item.isdefault = 0;
      });
    },

    //保存编辑的商品图片信息
    savethumbs() {
      this.thumbloading = true;
      let query = {
        act: 'savethumbs',
        token: this.$cookies.get('token'),
        id: this.thumbquery.id,
        thumbs: this.thumbs
      };

      var resource = this.$resource(this.url);
      resource.save(query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.thumbloading = false;
        } else {
          this.thumbloading = false;
          this.thumbDialog = false;
          this.getList();
        }
      }).catch((res) => {
        this.thumbloading = false;
      });
    },

    //获取金蝶对应物料信息
    getkingdeegoodslists(val) {
      this.customergetLoading = true;
      var resource = this.$resource(this.GLOBAL.domain + 'kingdee/index');
      resource.save({ act: 'getkingdeegoodsfromlocal', key: val, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.customergetLoading = false;
        } else {
          this.kingdeelists = JSON.parse(Base64.decode(res.data.Data));
          this.customergetLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.customergetLoading = false;
      });
    },

    //切换选中的数据
    changekingdeesetting(index) {
      var _this = this;
      this.setkingdeequery.kingdeeid = index;
      this.kingdeelists.forEach(function (item, i) {
        if (item.id == index) _this.setkingdeequery.kingdeename = item.name;
      });
    },

    /** 获取商品关联金蝶物料id数据 **/
    setKingdee(item) {
      this.kingdeeDialog = true;
      this.kingdeeloading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'getmatchkingdeeid', id: item.id, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.kingdeeloading = false;
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          this.setkingdeequery.productid = item.id;
          this.setkingdeequery.kingdeeid = result.kingdeeid;
          this.setkingdeequery.kingdeename = result.kingdeename;
          this.kingdeeloading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.kingdeeloading = false;
      });
    },

    /** 保存已选中的关联物料信息 **/
    savematchkingdee() {
      var resource = this.$resource(this.url);
      resource.save(this.setkingdeequery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          this.kingdeeDialog = false;
          this.getList();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },


    /** 将商品数据提交至金蝶 **/
    kingdeesellsubmit(item) {
      this.$confirm('警告：操作前请确认该商品是否已完结无需修改，数据一经提交至金蝶成功不可撤销', '提示', { type: 'warning' }).then(() => {
        var resource = this.$resource(this.url);
        resource.query({ act: 'productkingdeesubmit', id: item.id, token: this.$cookies.get('token') }).then((res) => {
          if (res.data.Result > 0) {
            if (res.data.Result == '70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
          } else {
            this.getList();
            this.$message.success('商品数据提交到金蝶成功');
          }
        }).catch((res) => {

        });
      }).catch(() => {

      });
    },


  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}

.imglists {
  float: left;
  width: 100%;
  padding: 0;
  margin: 0 0 20px 0
}

.imglists li {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(221, 221, 221, .5);
  float: left;
  width: 90px;
  height: 90px;
  border-radius: 5px;
  border: 1px solid #dddddd;
  margin: 20px 20px 0 0;
  list-style-type: none;
}

.imglists li a {
  float: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.imglists li img {
  float: left;
  max-width: 100%;
  max-height: 100%;
  border-radius: 5px
}

.thumbclose {
  width: 22px;
  height: 22px;
  margin: -90px 0 0 90px;
  position: absolute;
}

.thumbclose img {
  width: 22px;
  height: 22px;
}

.thumbdefault {
  position: absolute;
  margin: 85px 0 0 85px
}

.thumbdefault img {
  width: 25px;
  height: 25px;
}

.selects {
  background: #67C23A
}

.pd-infos-goods {
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
  width: 65px;
  height: 65px;
  overflow: hidden;
  border: 1px solid #dddddd;
  border-radius: 5px;
  background-color: rgba(221, 221, 221, .5);
}

.pd-infos-goods img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 5px
}

.pd-infos-desc {
  float: left;
  width: 66%;
  margin-left: 10px
}

.pd-infos-name {
  float: left;
  width: 100%;
  font-size: 13px;
  line-height: 21px;
  font-weight: 500;
}

.pd-infos-spec {
  font-size: 12px;
  color: #999999;
  float: left;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 14px;
  margin-top: 5px;
}

.pd-infos-inventorys,
.pd-infos-no-inventorys {
  font-size: 12px;
  line-height: 12px !important;
  padding: 4px 5px;
  font-style: normal;
  color: #fff;
  border-radius: 20px;
  position: absolute;
  top: 0;
  left: 0
}

.pd-infos-inventorys {
  background: #67C23A
}

.pd-infos-no-inventorys {
  background: #F56C6C
}

.product-size-style {
  font-size: 13px;
  font-weight: 500;
}

.cz-base-product-title {
  display: flex;
  align-items: center;
  width: calc(100% - 40px);
  padding: 20px 20px;
  font-size: 14px;
  font-weight: 700;
}

.cz-base-product-title i {
  width: 10px;
  height: 20px;
  border-radius: 6px;
  background: #e6a23c;
  margin-right: 5px;
}

.cz-product-edit-infos .el-form-item--small .el-form-item__content,
.el-form-item--small .el-form-item__label {
  font-size: 14px;
}

.cz-product-edit-infos .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  padding: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Product.vue